<div class="container">
  <div class="logo-wrapper">
    <img src="../../../../assets/img/Logo.svg" alt="Agucate Wallet" />
  </div>

  <!-- Loading inicial -->
  <div *ngIf="initialLoading && !registrationCompleted" class="step-content" style="align-items: center; justify-content: center; min-height: 200px;">
    <mat-icon class="analyzing-spinner-icon" style="font-size: 40px; width: 40px; height: 40px; color: #1E5A3F; animation: spin 1s linear infinite;">autorenew</mat-icon>
    <p class="subtext text-center">Cargando datos...</p>
  </div>

  <!-- Pantalla de verificación en proceso -->
  <div *ngIf="registrationCompleted && !initialLoading" class="step-content slide-enter">
    <div class="progress-wrapper">
      <div class="progress-pill">Registro enviado</div>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="100"></div>
      </div>
    </div>
    <div class="text-center mt-4">
      <mat-icon style="font-size: 64px; width: 64px; height: 64px; color: #f59e0b;">hourglass_empty</mat-icon>
    </div>
    <p class="main-question text-2xl text-center mt-2">
      Estamos verificando tu registro
    </p>
    <p class="subtext text-center">
      Tu solicitud de registro de empresa ha sido enviada exitosamente.
      Nuestro equipo está revisando tu información. Este proceso puede tomar
      hasta 48 horas hábiles.
    </p>
    <p class="subtext text-center mt-1">
      Te notificaremos por correo electrónico cuando tu cuenta esté verificada.
    </p>
    <button type="button" (click)="redirect('wallet/home')">Volver al inicio</button>
  </div>

  <div *ngIf="currentStep === 1 && !registrationCompleted && !initialLoading" class="step-content slide-enter">
    <div class="progress-wrapper" *ngIf="step1SubStep !== 'intro' && step1SubStep !== 'start-verification'">
      <div class="progress-pill">Paso {{ currentStep }}/7</div>
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="(currentStep / 7) * 100"
        ></div>
      </div>
    </div>

    <ng-container *ngIf="step1SubStep !== 'intro' && step1SubStep !== 'start-verification'">
      <p class="main-question"><strong>Representante Legal</strong></p>
      <p class="subtext">
        Verifica tu identidad capturando tu cedula chilena y una selfie.
      </p>
    </ng-container>

    <!-- ==================== SUB-STEP: INTRO (Checklist) ==================== -->
    <ng-container *ngIf="step1SubStep === 'intro'">
      <p class="main-question">
        <strong>Para registrar una empresa, primero necesitamos validar la identidad de su representante legal.</strong>
      </p>
      <p class="subtext">
        Para disfrutar de todos los beneficios vamos a verificar tu identidad y documentación básica.
      </p>

      <div class="intro-cards">
        <div class="intro-card">
          <div class="intro-card-icon">
            <mat-icon>badge</mat-icon>
          </div>
          <div class="intro-card-content">
            <p class="intro-card-title">RUT</p>
            <p class="intro-card-desc">Documentación que acredite su identidad vigente.</p>
          </div>
          <mat-icon class="intro-card-check">check_circle</mat-icon>
        </div>

        <div class="intro-card">
          <div class="intro-card-icon">
            <mat-icon>photo_camera</mat-icon>
          </div>
          <div class="intro-card-content">
            <p class="intro-card-title">Verificación de identidad</p>
            <p class="intro-card-desc">Documentos admitidos: Pasaporte, Cédula de identidad, Licencia de conducir USA, etc.</p>
          </div>
          <mat-icon class="intro-card-check">check_circle</mat-icon>
        </div>

        <div class="intro-card">
          <div class="intro-card-icon">
            <mat-icon>visibility</mat-icon>
          </div>
          <div class="intro-card-content">
            <p class="intro-card-title">Documentos legibles</p>
            <p class="intro-card-desc">La información debe leerse con claridad, sin distorsión o luz tenue.</p>
          </div>
          <mat-icon class="intro-card-check">check_circle</mat-icon>
        </div>

        <div class="intro-card">
          <div class="intro-card-icon">
            <mat-icon>crop_free</mat-icon>
          </div>
          <div class="intro-card-content">
            <p class="intro-card-title">Documento completo</p>
            <p class="intro-card-desc">El documento debe verse entero, sin cortes y sobre una superficie clara.</p>
          </div>
          <mat-icon class="intro-card-check">check_circle</mat-icon>
        </div>
      </div>

      <button type="button" (click)="step1SubStep = 'start-verification'">
        Continuar
      </button>
    </ng-container>

    <!-- ==================== SUB-STEP: START VERIFICATION ==================== -->
    <ng-container *ngIf="step1SubStep === 'start-verification'">
      <div class="shield-icon">
        <mat-icon>verified_user</mat-icon>
      </div>

      <p class="main-question text-center">
        <strong>Iniciar verificación</strong>
      </p>
      <p class="subtext text-center">
        Este proceso está diseñado para verificar su identidad y protegerte de robo de identidad.
      </p>

      <div class="recommendation-box">
        <p class="rec-title">Recomendaciones</p>
        <ul>
          <li><span class="icon">&#10004;</span> Utilice una identificación con fotografía válida emitida por el gobierno.</li>
          <li><span class="icon">&#10004;</span> Toma la imagen en un espacio bien iluminado.</li>
          <li><span class="icon">&#10004;</span> Prepárese para tomarse una selfie.</li>
        </ul>
      </div>

      <div class="consent-section">
        <label class="consent-label">
          <input type="checkbox" [(ngModel)]="biometricConsent" />
          <span>Doy mi consentimiento para que Aguacate Wallet recopile, procese y comparta mi información personal, que puede incluir datos biométricos, como se establece en su Política de privacidad.</span>
        </label>
      </div>

      <button type="button" (click)="step1SubStep = 'capture-front'" [disabled]="!biometricConsent">
        Empezar
      </button>

      <div class="actions">
        <button type="button" class="back-btn" (click)="step1SubStep = 'intro'">
          Volver
        </button>
      </div>
    </ng-container>

    <!-- ==================== SUB-STEP 1: CAPTURE FRONT ==================== -->
    <ng-container *ngIf="step1SubStep === 'capture-front'">
      <div class="phase-indicator">
        <span class="phase-badge">Paso 1 de 4</span>
      </div>

      <p class="main-question">
        <strong>Captura el <span class="highlight-front">FRENTE</span> de tu cedula chilena</strong>
      </p>
      <p class="subtext">
        Alinea el documento como en el ejemplo y toma la foto frontal.
      </p>

      <!-- Preview -->
      <div *ngIf="currentImage" class="capture-preview">
        <p class="subtext">Vista previa</p>
        <div class="preview-wrapper">
          <div class="image-container">
            <img
              [src]="currentImage"
              [style.transform]="'rotate(' + rotationAngle + 'deg)'"
              alt="Documento capturado"
            />
            <span class="overlay-text">Para uso exclusivo de verificacion de identidad</span>
          </div>
        </div>

        <div class="rotation-controls">
          <button type="button" (click)="rotateLeft()" [disabled]="ocrLoading">
            <mat-icon>rotate_left</mat-icon>
          </button>
          <button
            type="button"
            class="confirm-btn"
            (click)="confirmFrontDocument()"
            [disabled]="ocrLoading"
          >
            {{ ocrLoading ? 'Procesando OCR...' : 'Confirmar' }}
          </button>
          <button type="button" (click)="rotateRight()" [disabled]="ocrLoading">
            <mat-icon>rotate_right</mat-icon>
          </button>
        </div>

        <button
          type="button"
          class="retake-btn"
          (click)="retakeImage($event)"
          [disabled]="ocrLoading"
        >
          Tomar otra foto
        </button>
      </div>

      <!-- Example image -->
      <div class="example-wrapper" *ngIf="!currentImage">
        <img
          src="assets/img/runChile.png"
          alt="Ejemplo de cedula chilena"
          class="example-image"
        />
        <p class="example-label">Ejemplo de documento frontal</p>
      </div>

      <!-- Recommendations -->
      <div class="recommendation-box" *ngIf="!currentImage">
        <p class="rec-title">Recomendaciones</p>
        <ul>
          <li><span class="icon">&#10004;</span> Utilice una identificacion con fotografia valida emitida por el gobierno.</li>
          <li><span class="icon">&#10004;</span> Toma la imagen en un espacio bien iluminado.</li>
          <li><span class="icon">&#10004;</span> Asegurate de que todos los datos sean legibles.</li>
        </ul>
      </div>

      <!-- Camera button -->
      <button
        *ngIf="!currentImage"
        type="button"
        class="capture-button"
        (click)="openDocumentCamera()"
        [disabled]="ocrLoading"
      >
        Abrir camara
      </button>
    </ng-container>

    <!-- ==================== SUB-STEP 2: CAPTURE BACK ==================== -->
    <ng-container *ngIf="step1SubStep === 'capture-back'">
      <div class="phase-indicator">
        <span class="phase-badge">Paso 2 de 4</span>
      </div>

      <p class="main-question">
        <strong>Ahora captura el <span class="highlight-reverso">REVERSO</span> de tu cedula</strong>
      </p>
      <p class="subtext">
        Da vuelta tu cedula chilena y toma una foto del <strong>reverso</strong> (parte trasera).
      </p>

      <!-- Preview -->
      <div *ngIf="currentImage" class="capture-preview">
        <p class="subtext">Vista previa</p>
        <div class="preview-wrapper">
          <div class="image-container">
            <img
              [src]="currentImage"
              [style.transform]="'rotate(' + rotationAngle + 'deg)'"
              alt="Documento reverso"
            />
            <span class="overlay-text">Para uso exclusivo de verificacion de identidad</span>
          </div>
        </div>

        <div class="rotation-controls">
          <button type="button" (click)="rotateLeft()" [disabled]="ocrLoading">
            <mat-icon>rotate_left</mat-icon>
          </button>
          <button
            type="button"
            class="confirm-btn"
            (click)="confirmBackDocument()"
            [disabled]="ocrLoading"
          >
            {{ ocrLoading ? 'Procesando...' : 'Confirmar' }}
          </button>
          <button type="button" (click)="rotateRight()" [disabled]="ocrLoading">
            <mat-icon>rotate_right</mat-icon>
          </button>
        </div>

        <button
          type="button"
          class="retake-btn"
          (click)="retakeImage($event)"
          [disabled]="ocrLoading"
        >
          Tomar otra foto
        </button>
      </div>

      <!-- Example image -->
      <div class="example-wrapper" *ngIf="!currentImage">
        <img
          src="assets/img/reversoChile.jpeg"
          alt="Ejemplo reverso cedula"
          class="example-image reverso-example"
          onerror="this.src='assets/img/runChile.png'"
        />
        <p class="example-label reverso-label">
          <strong>REVERSO</strong> - Parte trasera del documento
        </p>
      </div>

      <!-- Camera button -->
      <button
        *ngIf="!currentImage"
        type="button"
        class="capture-button"
        (click)="openDocumentCamera()"
        [disabled]="ocrLoading"
      >
        Abrir camara
      </button>

      <div class="actions" *ngIf="!currentImage && !showCameraModal">
        <button type="button" class="back-btn" (click)="goBackStep1()" [disabled]="ocrLoading">
          Volver
        </button>
      </div>
    </ng-container>

    <!-- ==================== SUB-STEP 3: CAPTURE SELFIE ==================== -->
    <ng-container *ngIf="step1SubStep === 'capture-selfie'">
      <div class="phase-indicator">
        <span class="phase-badge">Paso 3 de 4</span>
      </div>

      <!-- IDLE STATE -->
      <ng-container *ngIf="faceVerificationStatus === 'idle'">
        <p class="main-question">
          <strong>Captura tu rostro</strong>
        </p>
        <p class="subtext">
          Tomaremos una foto de tu rostro para verificar que coincida con tu documento de identidad.
        </p>

        <!-- Selfie preview if captured -->
        <div *ngIf="currentImage" class="capture-preview">
          <div class="preview-wrapper">
            <div class="image-container selfie-preview-img">
              <img [src]="currentImage" alt="Selfie capturada" />
            </div>
          </div>

          <div class="rotation-controls">
            <button
              type="button"
              class="confirm-btn"
              (click)="confirmSelfie()"
              [disabled]="ocrLoading"
            >
              {{ ocrLoading ? 'Verificando...' : 'Confirmar' }}
            </button>
          </div>

          <button
            type="button"
            class="retake-btn"
            (click)="retakeSelfie()"
            [disabled]="ocrLoading"
          >
            Tomar otra foto
          </button>
        </div>

        <ng-container *ngIf="!currentImage">
          <!-- Face guide example -->
          <div class="example-wrapper">
            <div class="face-silhouette">
              <div class="oval-guide"></div>
            </div>
            <p class="example-label">Centra tu rostro en el ovalo</p>
          </div>

          <!-- Recommendations -->
          <div class="recommendation-box">
            <p class="rec-title">Recomendaciones</p>
            <ul>
              <li><span class="icon">&#10004;</span> Mira directamente a la camara</li>
              <li><span class="icon">&#10004;</span> Asegurate de estar en un lugar bien iluminado</li>
              <li><span class="icon">&#10004;</span> No uses lentes oscuros ni gorros</li>
              <li><span class="icon">&#10004;</span> Manten tu rostro descubierto</li>
            </ul>
          </div>

          <!-- Camera button -->
          <button
            type="button"
            class="capture-button"
            (click)="openSelfieCamera()"
            [disabled]="ocrLoading"
          >
            Abrir camara
          </button>
        </ng-container>

        <div class="actions" *ngIf="!currentImage && !showCameraModal">
          <button type="button" class="back-btn" (click)="goBackStep1()" [disabled]="ocrLoading">
            Volver
          </button>
        </div>
      </ng-container>

      <!-- ANALYZING STATE -->
      <ng-container *ngIf="faceVerificationStatus === 'analyzing'">
        <div class="analyzing-container">
          <div class="analyzing-spinner">
            <div class="spinner-ring"></div>
            <div class="face-icon">
              <mat-icon>face</mat-icon>
            </div>
          </div>
          <p class="analyzing-title">Analizando tu rostro...</p>
          <p class="analyzing-subtitle">Por favor espera, esto puede tomar unos segundos</p>
        </div>
      </ng-container>

      <!-- SUCCESS STATE -->
      <ng-container *ngIf="faceVerificationStatus === 'success'">
        <div class="result-container success-result">
          <div class="result-icon-wrapper success-icon">
            <mat-icon>check_circle</mat-icon>
          </div>
          <p class="result-title">Verificacion exitosa</p>
          <p class="result-subtitle">Tu identidad ha sido verificada correctamente.</p>
          <p class="similarity-badge success-badge">
            Coincidencia: {{ faceSimilarity | number:'1.0-0' }}%
          </p>
          <p class="auto-continue">Continuando automaticamente...</p>
        </div>
      </ng-container>

      <!-- ERROR STATE -->
      <ng-container *ngIf="faceVerificationStatus === 'error'">
        <div class="result-container error-result">
          <div class="result-icon-wrapper error-icon">
            <mat-icon>error</mat-icon>
          </div>
          <p class="result-title">No pudimos verificar</p>
          <p class="result-subtitle">{{ faceVerificationMessage }}</p>
          <p class="similarity-badge error-badge" *ngIf="faceSimilarity > 0">
            Coincidencia: {{ faceSimilarity | number:'1.0-0' }}%
          </p>

          <!-- Agotados los intentos: se ofrece ayuda en lugar de dejar al usuario
               reintentando indefinidamente. -->
          <p class="result-subtitle" *ngIf="faceAttemptsExhausted">
            Ya hiciste varios intentos. Escribenos por WhatsApp y te ayudamos a completar
            la verificacion.
          </p>
          <button
            type="button"
            class="continue-btn"
            *ngIf="faceAttemptsExhausted"
            (click)="contactSupport()"
          >
            Contactar soporte por WhatsApp
          </button>

          <button type="button" class="retry-btn" (click)="retakeSelfie()">
            Intentar de nuevo
          </button>
          <button type="button" class="back-btn" (click)="goBackStep1()">
            Volver al paso anterior
          </button>
        </div>
      </ng-container>
    </ng-container>

    <!-- ==================== SUB-STEP 4: FORM ==================== -->
    <ng-container *ngIf="step1SubStep === 'form'">
      <div class="phase-indicator">
        <span class="phase-badge">Paso 4 de 4</span>
      </div>

      <p class="main-question">
        <strong>Datos del Representante Legal</strong>
      </p>
      <p class="subtext">
        Verifica los datos obtenidos de tu cedula y completa los campos restantes.
      </p>

      <!-- Image thumbnails -->
      <div class="captured-thumbnails">
        <div class="thumbnail" *ngIf="documentFrontImage">
          <img [src]="documentFrontImage" alt="Frontal" />
          <span>Frontal</span>
        </div>
        <div class="thumbnail" *ngIf="documentBackImage">
          <img [src]="documentBackImage" alt="Reverso" />
          <span>Reverso</span>
        </div>
        <div class="thumbnail" *ngIf="selfieImage">
          <img [src]="selfieImage" alt="Selfie" class="selfie-thumb" />
          <span>Selfie</span>
        </div>
      </div>

      <form
        [formGroup]="representanteLegalForm"
        (ngSubmit)="nextStep()"
        class="form-wrapper mt-1"
      >
        <!-- OCR readonly fields -->
        <div class="form-grid">
          <div class="floating-group">
            <input type="text" formControlName="nombres" id="rep_nombres" readonly />
            <label for="rep_nombres">Nombres (OCR)</label>
          </div>

          <div class="floating-group">
            <input type="text" formControlName="apellidos" id="rep_apellidos" readonly />
            <label for="rep_apellidos">Apellidos (OCR)</label>
          </div>
        </div>

        <div class="form-grid">
          <div class="floating-group">
            <input type="text" formControlName="rut" id="rep_rut" readonly />
            <label for="rep_rut">RUT (OCR)</label>
          </div>

          <div class="floating-group flag-input">
            <select
              formControlName="nacionalidad"
              id="rep_nacionalidad"
              (change)="onCountryChange($event, 'nacionalidad')"
            >
              <option value="" disabled selected hidden></option>
              <option
                *ngFor="let country of countryPhoneOptions"
                [value]="country.name"
              >
                {{ country.name }}
              </option>
            </select>
            <label>Nacionalidad</label>
            <img
              class="flag-icon"
              *ngIf="representanteLegalForm.get('nacionalidad')?.value"
              [src]="
                'assets/flags/' +
                getFlagForCountry(representanteLegalForm.get('nacionalidad')?.value)
              "
              alt="Bandera"
            />
          </div>
        </div>

        <!-- Editable fields -->
        <div class="form-grid">
          <div class="floating-group">
            <input
              type="text"
              formControlName="direccion_particular"
              id="rep_direccion"
            />
            <label for="rep_direccion">Direccion particular</label>
          </div>

          <div class="floating-group">
            <input
              type="text"
              formControlName="tipo_departamento"
              id="rep_depto"
            />
            <label for="rep_depto">N de departamento (solo si aplica)</label>
          </div>
        </div>

        <div class="form-grid">
          <div class="floating-group">
            <input type="text" formControlName="comuna" id="rep_comuna" />
            <label for="rep_comuna">Comuna</label>
          </div>

          <div class="floating-group">
            <input type="text" formControlName="ciudad" id="rep_ciudad" />
            <label for="rep_ciudad">Ciudad</label>
          </div>
        </div>

        <div class="form-grid">
          <div class="floating-group flag-input">
            <select
              formControlName="pais_direccion"
              id="rep_pais_direccion"
              (change)="onCountryChange($event, 'paisDir')"
            >
              <option value="" disabled selected hidden></option>
              <option
                *ngFor="let country of countryPhoneOptions"
                [value]="country.name"
              >
                {{ country.name }}
              </option>
            </select>
            <label>Pais de direccion</label>
            <img
              class="flag-icon"
              *ngIf="representanteLegalForm.get('pais_direccion')?.value"
              [src]="
                'assets/flags/' +
                getFlagForCountry(representanteLegalForm.get('pais_direccion')?.value)
              "
              alt="Bandera"
            />
          </div>

          <div class="floating-group">
            <select
              formControlName="porcentaje_participacion"
              id="rep_porcentaje"
            >
              <option value="">Seleccione un porcentaje</option>
              <option *ngFor="let porcentaje of porcentajes" [value]="porcentaje">
                {{ porcentaje }}%
              </option>
            </select>
            <label for="rep_porcentaje">Porcentaje de participacion</label>
          </div>
        </div>

        <div class="form-grid">
          <div class="floating-group">
            <input
              type="date"
              formControlName="fecha_vencimiento_dni"
              id="rep_fecha_dni"
            />
            <label for="rep_fecha_dni">Fecha de vencimiento del DNI</label>
          </div>
        </div>

        <!-- PEP Section - Card Style -->
        <p class="main-question mt-2 text-center">
          <strong>¿Desempeña o ha desempeñado funciones públicas (PEP)?</strong>
        </p>
        <p class="subtext text-center">
          Selecciona la opción que corresponda a tu situación.
        </p>

        <div class="pep-options">
          <button
            type="button"
            class="pep-option"
            [class.selected]="representanteLegalForm.get('es_pep')?.value === false"
            (click)="setRepresentantePep(false)"
          >
            <div class="option-icon no-pep-icon">
              <mat-icon>person_outline</mat-icon>
            </div>
            <div class="option-content">
              <span class="option-title">No tiene vínculos políticos</span>
              <span class="option-desc">
                Declara que ni él ni sus familiares cercanos ocupan o han ocupado cargos políticos relevantes.
              </span>
            </div>
            <div class="pep-checkmark" *ngIf="representanteLegalForm.get('es_pep')?.value === false">
              <mat-icon>check_circle</mat-icon>
            </div>
          </button>

          <button
            type="button"
            class="pep-option"
            [class.selected]="representanteLegalForm.get('es_pep')?.value === true"
            (click)="setRepresentantePep(true)"
          >
            <div class="option-icon is-pep-icon">
              <mat-icon>account_balance</mat-icon>
            </div>
            <div class="option-content">
              <span class="option-title">Tiene vínculos políticos</span>
              <span class="option-desc">
                El representante o un familiar cercano ocupa o ha ocupado cargos políticos de alta relevancia.
              </span>
            </div>
            <div class="pep-checkmark" *ngIf="representanteLegalForm.get('es_pep')?.value === true">
              <mat-icon>check_circle</mat-icon>
            </div>
          </button>
        </div>

        <div class="pep-info-box">
          <div class="pep-info-header">
            <mat-icon>info</mat-icon>
            <span>¿Qué es una Persona Expuesta Políticamente (PEP)?</span>
          </div>
          <p class="pep-info-text">
            Son personas que desempeñan o han desempeñado funciones públicas destacadas, como:
            Presidente, Senadores, Diputados, Ministros de Estado, Jueces de altas cortes,
            Comandantes de Fuerzas Armadas, Directores de empresas públicas, entre otros.
          </p>
          <p class="pep-info-text pep-info-note">
            Incluye a familiares cercanos y socios comerciales de estas personas.
          </p>
        </div>

        <div *ngIf="representanteLegalForm.get('es_pep')?.value === true" class="pep-declaration-fields">
          <div class="section-divider">
            <span>Datos PEP</span>
          </div>
          <div class="form-grid">
            <div class="floating-group">
              <select formControlName="pep_funcion" id="rep_pep_funcion" class="form-control">
                <option value="" disabled selected hidden></option>
                <option value="Presidente de la República">Presidente de la República</option>
                <option value="Senadores, diputados y alcaldes">Senadores, diputados y alcaldes</option>
                <option value="Ministros de la Corte Suprema y Cortes de Apelaciones">Ministros de la Corte Suprema y Cortes de Apelaciones</option>
                <option value="Ministros de Estado">Ministros de Estado</option>
                <option value="Subsecretarios">Subsecretarios</option>
                <option value="Intendentes">Intendentes</option>
                <option value="Gobernadores">Gobernadores</option>
                <option value="Secretarios Regionales Ministeriales">Secretarios Regionales Ministeriales</option>
                <option value="Embajadores">Embajadores</option>
                <option value="Jefes superiores de servicio (centralizados y descentralizados)">Jefes superiores de servicio</option>
                <option value="Comandantes en Jefe de las Fuerzas Armadas">Comandantes en Jefe de las Fuerzas Armadas</option>
                <option value="Director General de Carabineros">Director General de Carabineros</option>
                <option value="Director General de Investigaciones">Director General de Investigaciones</option>
                <option value="Fiscales Regionales">Fiscales Regionales</option>
                <option value="Contralor General de la República">Contralor General de la República</option>
                <option value="Consejeros del Banco Central de Chile">Consejeros del Banco Central de Chile</option>
                <option value="Otros">Otros</option>
              </select>
              <label for="rep_pep_funcion">¿Qué funciones desempeñó?</label>
            </div>

            <div class="floating-group">
              <input
                type="text"
                formControlName="pep_institucion"
                id="rep_pep_institucion"
                placeholder="Ingrese la institución"
              />
              <label for="rep_pep_institucion">¿En qué institución?</label>
            </div>
          </div>

          <div class="form-grid">
            <div class="floating-group">
              <input type="date" formControlName="pep_fecha_inicio" id="rep_pep_inicio" />
              <label for="rep_pep_inicio">Fecha de inicio</label>
            </div>

            <div class="floating-group">
              <input type="date" formControlName="pep_fecha_termino" id="rep_pep_termino" />
              <label for="rep_pep_termino">Fecha de término</label>
            </div>
          </div>
        </div>

        <p class="subtext">
          Los datos personales otorgados se utilizaran solo por
          <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
          conocimiento de sus clientes. No seran divulgados ni puestos en
          conocimiento publico, esto conforme al cumplimiento de la Ley N 19.628
          sobre Proteccion de Vida Privada.
        </p>

        <button type="submit" [disabled]="!representanteLegalForm.valid || ocrLoading">
          {{ ocrLoading ? 'Guardando...' : 'Continuar' }}
        </button>
      </form>

      <div class="actions">
        <button type="button" class="back-btn" (click)="goBackStep1()" [disabled]="ocrLoading">
          Volver
        </button>
      </div>
    </ng-container>

    <!-- ==================== CAMERA MODAL ==================== -->
    <div class="camera-modal" *ngIf="showCameraModal">
      <div class="camera-wrapper">
        <p class="camera-guide-text" *ngIf="cameraPurpose === 'document'">Alinea tu documento dentro del marco</p>
        <p class="camera-guide-text" *ngIf="cameraPurpose === 'selfie'">Centra tu rostro en la pantalla</p>

        <div class="camera-container" [ngClass]="{'selfie-camera': cameraPurpose === 'selfie'}">
          <video #video autoplay playsinline></video>

          <!-- Document frame (only for document capture) -->
          <div class="document-frame" *ngIf="cameraPurpose === 'document'">
            <div class="corner top-left"></div>
            <div class="corner top-right"></div>
            <div class="corner bottom-left"></div>
            <div class="corner bottom-right"></div>
          </div>

          <!-- Face guide (only for selfie) -->
          <div class="face-guide-overlay" *ngIf="cameraPurpose === 'selfie'">
            <div class="oval-mask"></div>
          </div>
        </div>

        <div class="button-group">
          <button
            type="button"
            class="capture-button-overlay"
            (click)="cameraPurpose === 'document' ? captureDocument() : captureSelfie()"
            [disabled]="!isReadyToCapture"
          >
            Tomar foto
          </button>
          <button
            type="button"
            class="close-button"
            (click)="closeCameraModal()"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="currentStep === 2 && !initialLoading" class="step-content slide-enter">
    <div class="progress-wrapper">
      <div class="progress-pill">Paso {{ currentStep }}/7</div>
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="(currentStep / 7) * 100"
        ></div>
      </div>
    </div>

    <p class="main-question"><strong>Persona Juridica</strong></p>
    <p class="subtext">
      Ingresa los datos de tu empresa, organizacion o negocio
    </p>

    <form
      [formGroup]="personaJuridicaForm"
      class="form-wrapper mt-1"
    >
      <!-- ==================== SUB-STEP 1 de 2: Datos empresa ==================== -->
      <ng-container *ngIf="step2SubStep === 1">
        <div class="phase-indicator">
          <span class="phase-badge">Paso 1 de 2</span>
        </div>

        <p class="main-question">
          <strong>Datos de la empresa</strong>
        </p>

        <div class="form-grid">
          <div class="floating-group">
            <input type="text" formControlName="razonSocial" id="razonSocial" />
            <label for="razonSocial">Nombre oficial (razon social)</label>
          </div>

          <div class="floating-group">
            <input
              type="text"
              formControlName="nombreFantasia"
              id="nombreFantasia"
            />
            <label for="nombreFantasia">Nombre de fantasia</label>
          </div>
        </div>

        <div class="form-grid">
          <div class="floating-group">
            <input
              type="text"
              formControlName="giroComercial"
              id="giroComercial"
            />
            <label for="giroComercial">Giro comercial</label>
          </div>

          <div class="floating-group">
            <input
              type="date"
              formControlName="fechaConstitucion"
              id="fechaConstitucion"
            />
            <label for="fechaConstitucion">Fecha de constitucion</label>
          </div>
        </div>

        <div class="form-grid">
          <div class="floating-group">
            <input type="text" formControlName="rut" id="rut" />
            <label for="rut">RUT</label>
          </div>

          <div class="floating-group phone-field">
            <div class="phone-group">
              <div class="custom-select" (click)="showDropdown = !showDropdown">
                <img *ngIf="selectedFlag" [src]="selectedFlag" alt="Bandera" />
                <span>{{ selectedCode || "+XX" }}</span>
              </div>

              <div
                *ngIf="showDropdown"
                class="custom-dropdown"
              >
                <div
                  class="option"
                  *ngFor="let country of countryPhoneOptions"
                  (click)="selectPhone(country.code, country.flag)"
                >
                  <img
                    [src]="'assets/flags/' + country.flag"
                    [alt]="country.name"
                  />
                  <span>{{ country.code }} {{ country.name }}</span>
                </div>
              </div>

              <input
                type="tel"
                formControlName="telefono"
                id="telefono1"
                maxlength="10"
                (keypress)="allowOnlyNumbers($event)"
                (blur)="showErrorPersonaJuridicaForm('telefono')"
              />
              <label for="telefono1">Telefono</label>
            </div>
          </div>
        </div>

        <div class="actions">
          <button type="button" class="capture-button" (click)="nextStep2SubStep()">
            Continuar
          </button>
          <button type="button" class="retake-btn" (click)="prevStep()">
            Volver
          </button>
        </div>
      </ng-container>

      <!-- ==================== SUB-STEP 2 de 2: Direccion + motivo ==================== -->
      <ng-container *ngIf="step2SubStep === 2">
        <div class="phase-indicator">
          <span class="phase-badge">Paso 2 de 2</span>
        </div>

        <p class="main-question">
          <strong>Direccion y relacion comercial</strong>
        </p>

        <div class="form-grid">
          <div class="floating-group">
            <select formControlName="pais" id="pais">
              <option value=""></option>
              <option
                *ngFor="let country of countryPhoneOptions"
                [value]="country.name"
              >
                {{ country.name }}
              </option>
            </select>
            <label for="pais">Pais</label>
          </div>

          <div class="floating-group">
            <input type="text" formControlName="ciudad" id="ciudad" />
            <label for="ciudad">Ciudad</label>
          </div>
        </div>

        <div class="form-grid">
          <div class="floating-group">
            <input type="text" formControlName="comuna" id="comuna" />
            <label for="comuna">Comuna</label>
          </div>

          <div class="floating-group">
            <input type="text" formControlName="direccion" id="direccion" />
            <label for="direccion">Direccion</label>
          </div>
        </div>

        <div class="form-grid">
          <div class="floating-group">
            <input type="text" formControlName="oficina" id="oficina" />
            <label for="oficina">N de oficina (Opcional)</label>
          </div>

          <div class="floating-group">
            <select formControlName="motivoRelacion2" id="motivoRelacion2">
              <option value=""></option>
              <option value="ahorro">Ahorro</option>
              <option value="inversion">Inversion</option>
              <option value="trading">Trading</option>
              <option value="pago_servicios">Pago de servicios</option>
              <option value="otros">Otros</option>
            </select>
            <label for="motivoRelacion2"
              >Motivo de la relacion comercial / contractual</label
            >
          </div>
        </div>

        <p class="subtext">
          Los datos personales otorgados se utilizaran solo por
          <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
          conocimiento de sus clientes. No seran divulgados ni puestos en
          conocimiento publico, esto conforme al cumplimiento de la Ley N 19.628
          sobre Proteccion de Vida Privada.
        </p>

        <div class="actions">
          <button type="button" class="capture-button" [disabled]="!personaJuridicaForm.valid || isSavingStep" (click)="nextStep()">
            {{ isSavingStep ? 'Guardando...' : 'Continuar' }}
          </button>
          <button type="button" class="retake-btn" (click)="prevStep2SubStep()">
            Volver
          </button>
        </div>
      </ng-container>
    </form>
  </div>

  <div *ngIf="currentStep === 3 && !initialLoading" class="step-content slide-enter">
    <div class="progress-wrapper">
      <div class="progress-pill">Paso {{ currentStep }}/7</div>
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="(currentStep / 9) * 100"
        ></div>
      </div>
    </div>

    <p class="main-question"><strong>Información del negocio</strong></p>
    <p class="subtext">
      Ingresa los datos de tu empresa, organización o negocio.
    </p>

    <form
      [formGroup]="informacionNegocioForm"
      (ngSubmit)="nextStep()"
      class="form-wrapper mt-1"
    >
      <div class="form-grid">
        <div class="floating-group">
          <input
            type="text"
            formControlName="descripcionNegocio"
            id="descripcionNegocio"
          />
          <label for="descripcionNegocio">Breve descripción del negocio</label>
        </div>

        <div class="floating-group">
          <input
            type="text"
            formControlName="descripcionOrigenFondos"
            id="descripcionOrigenFondos"
          />
          <label for="descripcionOrigenFondos"
            >Descripción de origen de fondos</label
          >
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <select formControlName="origenFondos" id="origenFondos">
            <option value="">Seleccionar</option>
            <option value="Herencia">Herencia</option>
            <option value="Inversiones">Inversiones</option>
            <option value="Salario">Salario</option>
            <option value="Actividad productiva">Actividad productiva</option>
            <option value="Bienes raices">Bienes raices</option>
            <option value="otros">Otros</option>
          </select>
          <label for="origenFondos">Origen de fondos</label>
        </div>

        <div class="floating-group">
          <select formControlName="ingresosMensuales" id="ingresosMensuales">
            <option value="">Seleccionar</option>
            <option value="Menor a 1,000 USD">Menor a 1,000 USD</option>
            <option value="Entre 1,000 y 3,000 USD">
              Entre 1,000 y 3,000 USD
            </option>
            <option value="Entre 3,000 y 5,000 USD">
              Entre 3,000 y 5,000 USD
            </option>
            <option value="Entre 5,000 y 10,000 USD">
              Entre 5,000 y 10,000 USD
            </option>
            <option value="Entre 10,000 y 20,000 USD">
              Entre 10,000 y 20,000 USD
            </option>
            <option value="Mayor a 20,000 USD">Mayor a 20,000 USD</option>
          </select>
          <label for="ingresosMensuales">Ingresos mensuales (USD)</label>
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <select formControlName="patrimonioTotal" id="patrimonioTotal">
            <option value="">Seleccionar</option>
            <option value="Menor a 10,000 USD">Menor a 10,000 USD</option>
            <option value="Entre 10,000 y 50,000 USD">
              Entre 10,000 y 50,000 USD
            </option>
            <option value="Entre 50,000 y 100,000 USD">
              Entre 50,000 y 100,000 USD
            </option>
            <option value="Entre 100,000 y 500,000 USD">
              Entre 100,000 y 500,000 USD
            </option>
            <option value="Mayor a 500,000 USD">Mayor a 500,000 USD</option>
          </select>
          <label for="patrimonioTotal">Patrimonio total (en USD)</label>
        </div>

        <div class="floating-group">
          <select
            formControlName="patrimonioFinanciero"
            id="patrimonioFinanciero"
          >
            <option value="">Seleccionar</option>
            <option value="Menor a 10,000 USD">Menor a 10,000 USD</option>
            <option value="Entre 10,000 y 50,000 USD">
              Entre 10,000 y 50,000 USD
            </option>
            <option value="Entre 50,000 y 100,000 USD">
              Entre 50,000 y 100,000 USD
            </option>
            <option value="Entre 100,000 y 500,000 USD">
              Entre 100,000 y 500,000 USD
            </option>
            <option value="Mayor a 500,000 USD">Mayor a 500,000 USD</option>
          </select>
          <label for="patrimonioFinanciero"
            >Patrimonio financiero (en USD)</label
          >
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <select formControlName="actividadEconomica" id="actividadEconomica">
            <option value="">Seleccionar</option>
            <option value="software">
              VENTA AL POR MAYOR DE EQUIPO, PARTES Y PIEZAS ELECTRONICO Y DE
              TELECO
            </option>
            <option value="comercio">
              OTRAS ACTIVIDADES DE VENTA AL POR MENOR EN COMERCIOS NO
              ESPECIALIZADOS
            </option>
            <option value="servicios">
              OTRAS ACTIVIDADES AUXILIARES DE SERVICIOS FINANCIEROS
            </option>
            <option value="otros">OTROS</option>
          </select>
          <label for="actividadEconomica"
            >Actividad económica ante S.I.I.</label
          >
        </div>

        <div class="floating-group">
          <select
            formControlName="cantidadOperacionesMensuales"
            id="cantidadOperacionesMensuales"
          >
            <option value="">Seleccionar</option>
            <option value="Menos de 50">Menos de 50</option>
            <option value="Entre 50 y 100">Entre 50 y 100</option>
            <option value="Entre 100 y 500">Entre 100 y 500</option>
            <option value="Mas de 500">Más de 500</option>
          </select>
          <label for="cantidadOperacionesMensuales">
            Cantidad de operaciones mensuales
          </label>
        </div>
      </div>

      <div class="floating-group full-width">
        <input
          type="text"
          pattern="[0-9]*"
          inputmode="numeric"
          formControlName="volumenOperacionesMensuales"
          id="volumenOperacionesMensuales"
        />
        <label for="volumenOperacionesMensuales"
          >Volumen de operaciones mensuales (en USD)</label
        >
      </div>

      <p class="subtext">
        Los datos personales otorgados se utilizarán solo por
        <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
        conocimiento de sus clientes. No serán divulgados ni puestos en
        conocimiento público, esto conforme al cumplimiento de la Ley N° 19.628
        sobre Protección de Vida Privada.
      </p>

      <button type="submit" [disabled]="!informacionNegocioForm.valid || isSavingStep">
        {{ isSavingStep ? 'Guardando...' : 'Continuar' }}
      </button>
    </form>
  </div>

  <div *ngIf="currentStep === 4 && !initialLoading" class="step-content slide-enter">
    <div class="progress-wrapper">
      <div class="progress-pill">Paso {{ currentStep }}/7</div>
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="(currentStep / 7) * 100"
        ></div>
      </div>
    </div>

    <p class="main-question"><strong>Beneficiario final</strong></p>
    <p class="subtext">
      Se considera a la(s) persona(s) natural(es) que finalmente posee, directa
      o indirectamente, a través de sociedades u otros mecanismos, una
      participación igual o mayor al 10% del capital o de los derechos a voto de
      una persona jurídica o estructura jurídica determinada. Asimismo, se
      entenderá como Beneficiario Final a la(s) persona(s) natural(es) que, sin
      perjuicio de poseer, directa o indirectamente, una participación inferior
      al 10% del capital o de los derechos a voto de una persona jurídica o
      estructura jurídica, a través de sociedades u otros mecanismos, ejerce el
      control efectivo en la toma de decisiones de la persona jurídica o
      estructura jurídica.
    </p>

    <form
      [formGroup]="beneficiarioFinalForm"
      (ngSubmit)="nextStep()"
      class="form-wrapper mt-1"
    >
      <!-- OCR Pre-fill option -->
      <div class="ocr-prefill-card" *ngIf="representanteLegalForm.get('nombres')?.value && !beneficiarioIsRepresentante">
        <div class="prefill-header">
          <mat-icon>person_search</mat-icon>
          <span>¿Es el mismo representante legal?</span>
        </div>
        <p class="prefill-desc">Si el beneficiario es la misma persona, usa los datos ya capturados.</p>
        <button type="button" class="prefill-btn" (click)="prefillBeneficiarioFromOcr()">
          Usar datos del representante legal
        </button>
      </div>

      <div *ngIf="beneficiarioIsRepresentante" class="documents-from-step1">
        <div class="prefill-success">
          <mat-icon>check_circle</mat-icon>
          <span>Datos copiados del representante legal. Documentos ya capturados en el paso 1.</span>
        </div>
        <div class="captured-thumbnails mt-1" *ngIf="documentFrontImage || documentBackImage">
          <div class="thumbnail" *ngIf="documentFrontImage">
            <img [src]="documentFrontImage" alt="Frontal" />
            <span>Frontal</span>
          </div>
          <div class="thumbnail" *ngIf="documentBackImage">
            <img [src]="documentBackImage" alt="Reverso" />
            <span>Reverso</span>
          </div>
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <input
            type="text"
            class="form-control"
            formControlName="nombres"
            id="nombres"
          />
          <label for="nombres">Nombres</label>
        </div>

        <div class="floating-group">
          <input
            type="text"
            class="form-control"
            formControlName="apellidos"
            id="apellidos"
          />
          <label for="apellidos">Apellidos</label>
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <input
            type="text"
            class="form-control"
            formControlName="rut"
            id="rut"
          />
          <label for="rut">RUT</label>
        </div>

        <div class="floating-group">
          <div class="floating-group flag-input">
            <select
              formControlName="nacionalidad"
              id="nacionalidad"
              (change)="onCountryChange($event, 'nacionalidad2')"
            >
              <option value="" disabled selected hidden></option>
              <option
                *ngFor="let country of countryPhoneOptions"
                [value]="country.name"
              >
                {{ country.name }}
              </option>
            </select>
            <label>Nacionalidad</label>
            <img
              class="flag-icon"
              *ngIf="beneficiarioFinalForm.get('nacionalidad')?.value"
              [src]="
                'assets/flags/' +
                getFlagForCountry(
                  beneficiarioFinalForm.get('nacionalidad')?.value
                )
              "
              alt="Bandera"
            />
          </div>
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <select
            class="form-control"
            formControlName="porcentaje_participacion"
            id="porcentaje_participacion"
          >
            <option value="">Seleccione un porcentaje</option>
            <option *ngFor="let porcentaje of porcentajes" [value]="porcentaje">
              {{ porcentaje }}%
            </option>
          </select>
          <label for="">Porcentaje de participación</label>
        </div>

        <div class="floating-group">
          <input
            type="text"
            class="form-control"
            formControlName="direccion_particular"
            id="direccion_particular"
          />
          <label for="direccion_particular">Dirección particular</label>
        </div>
      </div>
      <div class="form-grid">
        <div class="floating-group">
          <input
            type="text"
            class="form-control"
            formControlName="tipo_departamento"
          />
          <label for="tipo_departamento"
            >N° de departamento (solo si aplica)</label
          >
        </div>

        <div class="floating-group">
          <input
            type="text"
            class="form-control"
            formControlName="comuna"
            id="comuna"
          />
          <label for="comuna">Comuna</label>
        </div>
      </div>

      <div class="form-grid">
        <div class="floating-group">
          <input
            type="text"
            class="form-control"
            formControlName="ciudad"
            id="ciudad"
          />
          <label for="ciudad">Ciudad</label>
        </div>

        <div class="floating-group flag-input">
          <select
            formControlName="pais_direccion"
            id="pais_direccion"
            (change)="onCountryChange($event, 'paisDir')"
          >
            <option value="" disabled selected hidden></option>
            <option
              *ngFor="let country of countryPhoneOptions"
              [value]="country.name"
            >
              {{ country.name }}
            </option>
          </select>
          <label>Pais de direccion</label>
          <img
            class="flag-icon"
            *ngIf="beneficiarioFinalForm.get('pais_direccion')?.value"
            [src]="
              'assets/flags/' +
              getFlagForCountry(beneficiarioFinalForm.get('pais_direccion')?.value)
            "
            alt="Bandera"
          />
        </div>
      </div>

      <p class="main-question text-center" *ngIf="!beneficiarioIsRepresentante">Documento Nacional de Identidad</p>

      <div class="form-grid" *ngIf="!beneficiarioIsRepresentante">
        <div class="floating-group">
          <input
            type="file"
            id="documento_frontal"
            (change)="onFileSelected($event, 'documento_frontal')"
            accept=".jpg, .jpeg, .png"
            #fileInput
          />
          <label for="documento_frontal">Adjunte su documento FRONTAL</label>
          <small class="block text-xs sm:text-sm text-gray-500 mt-1 text-center"
            >Máximo 5 MB - Formatos PNG, JPG y JPEG</small
          >
        </div>

        <div class="floating-group">
          <input
            type="file"
            id="documento_reverso"
            (change)="onFileSelected($event, 'documento_reverso')"
            accept=".jpg, .jpeg, .png"
            #fileInput
          />
          <label for="documento_reverso">Adjunte su documento REVERSO</label>
          <small class="block text-xs sm:text-sm text-gray-500 mt-1 text-center"
            >Máximo 10 MB - Formatos PNG, JPG y JPEG</small
          >
        </div>
      </div>

      <div class="form-grid mt-3">
        <div class="floating-group">
          <input
            type="date"
            class="form-control"
            formControlName="fecha_vencimiento_dni"
            id="fecha_vencimiento_dni"
          />
          <label for="fecha_vencimiento_dni"
            >Fecha de vencimiento del DNI</label
          >
        </div>
      </div>

      <!-- PEP Section - Card Style (Obligatorio) -->
      <p class="main-question mt-2 text-center">
        <strong>¿Desempeña o ha desempeñado funciones públicas (PEP)?</strong>
        <span class="text-red-500">*</span>
      </p>
      <p class="subtext text-center">
        Selecciona la opción que corresponda a la situación del beneficiario.
      </p>

      <div class="pep-options">
        <button
          type="button"
          class="pep-option"
          [class.selected]="beneficiarioFinalForm.get('es_pep')?.value === false"
          (click)="setBeneficiarioPep(false)"
        >
          <div class="option-icon no-pep-icon">
            <mat-icon>person_outline</mat-icon>
          </div>
          <div class="option-content">
            <span class="option-title">No tiene vinculos politicos</span>
            <span class="option-desc">
              Declara que ni el ni sus familiares cercanos ocupan o han ocupado cargos politicos relevantes.
            </span>
          </div>
          <div class="pep-checkmark" *ngIf="beneficiarioFinalForm.get('es_pep')?.value === false">
            <mat-icon>check_circle</mat-icon>
          </div>
        </button>

        <button
          type="button"
          class="pep-option"
          [class.selected]="beneficiarioFinalForm.get('es_pep')?.value === true"
          (click)="setBeneficiarioPep(true)"
        >
          <div class="option-icon is-pep-icon">
            <mat-icon>account_balance</mat-icon>
          </div>
          <div class="option-content">
            <span class="option-title">Tiene vinculos politicos</span>
            <span class="option-desc">
              El beneficiario o un familiar cercano ocupa o ha ocupado cargos politicos de alta relevancia.
            </span>
          </div>
          <div class="pep-checkmark" *ngIf="beneficiarioFinalForm.get('es_pep')?.value === true">
            <mat-icon>check_circle</mat-icon>
          </div>
        </button>
      </div>

      <p class="text-red-500 text-xs text-center mt-1"
         *ngIf="beneficiarioFinalForm.get('es_pep')?.touched && beneficiarioFinalForm.get('es_pep')?.hasError('required')">
        Debes seleccionar una opción antes de continuar.
      </p>

      <div class="pep-info-box">
        <div class="pep-info-header">
          <mat-icon>info</mat-icon>
          <span>¿Qué es una Persona Expuesta Políticamente (PEP)?</span>
        </div>
        <p class="pep-info-text">
          Son personas que desempeñan o han desempeñado funciones públicas destacadas, como:
          Presidente, Senadores, Diputados, Ministros de Estado, Jueces de altas cortes,
          Comandantes de Fuerzas Armadas, Directores de empresas públicas, entre otros.
        </p>
        <p class="pep-info-text pep-info-note">
          Incluye a familiares cercanos y socios comerciales de estas personas.
        </p>
      </div>

      <div *ngIf="beneficiarioFinalForm.get('es_pep')?.value === true" class="pep-declaration-fields">
        <div class="section-divider">
          <span>Datos PEP</span>
        </div>
        <div class="form-grid">
          <div class="floating-group">
            <select
              formControlName="pep_funcion"
              id="pep_funcion"
              class="form-control"
            >
              <option value="" disabled selected hidden></option>
              <option value="Presidente de la República">
                Presidente de la República
              </option>
              <option value="Senadores, diputados y alcaldes">
                Senadores, diputados y alcaldes
              </option>
              <option
                value="Ministros de la Corte Suprema y Cortes de Apelaciones"
              >
                Ministros de la Corte Suprema y Cortes de Apelaciones
              </option>
              <option value="Ministros de Estado">Ministros de Estado</option>
              <option value="Subsecretarios">Subsecretarios</option>
              <option value="Intendentes">Intendentes</option>
              <option value="Gobernadores">Gobernadores</option>
              <option value="Secretarios Regionales Ministeriales">
                Secretarios Regionales Ministeriales
              </option>
              <option value="Embajadores">Embajadores</option>
              <option
                value="Jefes superiores de servicio (centralizados y descentralizados)"
              >
                Jefes superiores de servicio (centralizados y descentralizados)
              </option>
              <option
                value="Directivo superior inmediato que subrogue a los anteriores"
              >
                Directivo superior inmediato que subrogue a los anteriores
              </option>
              <option value="Comandantes en Jefe de las Fuerzas Armadas">
                Comandantes en Jefe de las Fuerzas Armadas
              </option>
              <option value="Director General de Carabineros">
                Director General de Carabineros
              </option>
              <option value="Director General de Investigaciones">
                Director General de Investigaciones
              </option>
              <option
                value="Oficial superior inmediato que subrogue a los anteriores"
              >
                Oficial superior inmediato que subrogue a los anteriores
              </option>
              <option value="Fiscales Regionales">Fiscales Regionales</option>
              <option value="Contralor General de la República">
                Contralor General de la República
              </option>
              <option value="Consejeros del Banco Central de Chile">
                Consejeros del Banco Central de Chile
              </option>
              <option value="Consejeros del Consejo de Defensa del Estado">
                Consejeros del Consejo de Defensa del Estado
              </option>
              <option value="Ministros del Tribunal de la Libre Competencia">
                Ministros del Tribunal de la Libre Competencia
              </option>
              <option
                value="Integrantes titulares y suplentes del Tribunal de Contratación Pública"
              >
                Integrantes titulares y suplentes del Tribunal de Contratación
                Pública
              </option>
              <option value="Consejeros del Consejo de Alta Dirección Pública">
                Consejeros del Consejo de Alta Dirección Pública
              </option>
              <option
                value="Directores y ejecutivos principales de empresas públicas (según Ley N° 18.045)"
              >
                Directores y ejecutivos principales de empresas públicas (según
                Ley N° 18.045)
              </option>
              <option
                value="Directores de sociedades anónimas nombrados por el Estado o sus organismos"
              >
                Directores de sociedades anónimas nombrados por el Estado o sus
                organismos
              </option>
              <option
                value="Miembros de las directivas de los partidos políticos"
              >
                Miembros de las directivas de los partidos políticos
              </option>
              <option value="Otros">Otros</option>
            </select>
            <label for="pep_funcion">¿Qué funciones desempeñó?</label>
          </div>

          <div class="floating-group">
            <input
              type="text"
              id="pep_institucion"
              formControlName="pep_institucion"
              class="form-control"
              placeholder="Ingrese la institución"
            />
            <label for="pep_institucion">¿En qué institución?</label>
          </div>
        </div>

        <div class="form-grid mt-4">
          <div class="floating-group">
            <input
              type="date"
              class="form-control"
              formControlName="pep_fecha_inicio"
              id="pep_fecha_inicio"
            />
            <label for="pep_fecha_inicio">Fecha de inicio</label>
          </div>

          <div class="floating-group">
            <input
              type="date"
              class="form-control"
              formControlName="pep_fecha_termino"
              id="pep_fecha_termino"
            />
            <label for="pep_fecha_termino">Fecha de término</label>
          </div>
        </div>
      </div>

      <p class="subtext">
        Los datos personales otorgados se utilizarán solo por
        <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
        conocimiento de sus clientes. No serán divulgados ni puestos en
        conocimiento público, esto conforme al cumplimiento de la Ley N° 19.628
        sobre Protección de Vida Privada.
      </p>

      <button type="submit" [disabled]="!beneficiarioFinalForm.valid || isSavingStep">
        {{ isSavingStep ? 'Guardando...' : 'Continuar' }}
      </button>
    </form>
  </div>

  <div *ngIf="currentStep === 5 && !initialLoading" class="step-content slide-enter">
    <div class="progress-wrapper">
      <div class="progress-pill">Paso {{ currentStep }}/7</div>
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="(currentStep / 7) * 100"
        ></div>
      </div>
    </div>

    <p class="main-question"><strong>Socios</strong></p>
    <p class="subtext">
      Verifica los datos correctos de tus socios comerciales.
    </p>

    <div class="existing-beneficiaries">
      <div class="form-grid justify-between py-2">
        <p class="main-question italic self-center">
          1. Datos beneficiarios finales ({{ beneficiarios.length }})
          <mat-icon
            matTooltip="Se consideran beneficiarios finales aquellas personas naturales que poseen, directa o indirectamente, al menos un 10 % de la propiedad o participación de la empresa, o que de alguna manera ejercen control significativo sobre la misma.
👉 Ejemplo: si una persona posee el 20 % de las acciones de la empresa, debe ser registrada como beneficiario final."
            matTooltipPosition="right"
            class="text-sm cursor-pointer align-middle"
            fontIcon="help_outline"
            inline
          ></mat-icon>
        </p>

        <button
          type="button"
          class="text-xs flex items-center justify-between w-[260px] shadow-md mw-[250px]"
          (click)="addBeneficiary()"
        >
          Ingresar beneficiario final
          <mat-icon fontIcon="add"></mat-icon>
        </button>
      </div>
      <div
        *ngIf="beneficiarios.length > 0; else noBeneficiaries"
        class="space-y-4"
      >
        <div
          class="beneficiary-item flex place-content-around gap-4 p-4 shadow-sm bg-white"
          *ngFor="let beneficiary of beneficiarios"
        >
          <div class="text-sm space-y-1">
            <p>
              <span class="text-gray-500 font-normal">Nombres: </span>
              <span class="[color:#09342D]">{{ beneficiary.nombres }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal">Apellidos: </span>
              <span class="[color:#09342D]">{{ beneficiary.apellidos }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal"
                >Cédula de identidad:
              </span>
              <span class="[color:#09342D]">{{ beneficiary.rut }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal">¿PEP?: </span>
              <span class="[color:#09342D]">{{
                beneficiary.es_pep ? "Sí" : "No"
              }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal">Participación: </span>
              <span class="[color:#09342D]"
                >{{ beneficiary.porcentaje_participacion }}%</span
              >
            </p>
          </div>
          <button
            class="flex items-center gap-1 [color:#FF2048] hover:[color:#e10032] text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            [disabled]="beneficiarios.length < 2"
            (click)="deleteBeneficiary(beneficiary.id)"
          >
            Eliminar
          </button>
        </div>
      </div>
      <div *ngIf="openBeneficiaryForm" class="modal-backdrop">
        <div class="modal-content">
          <form
            [formGroup]="beneficiarioFinalForm2"
            (ngSubmit)="addNewBeneficiary()"
            class="form-wrapper mt-1"
          >
            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="nombres"
                  id="nombres"
                />
                <label for="nombres">Nombres</label>
              </div>

              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="apellidos"
                  id="apellidos"
                />
                <label for="apellidos">Apellidos</label>
              </div>
            </div>

            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="rut"
                  id="rut"
                />
                <label for="rut">RUT</label>
              </div>

              <div class="floating-group">
                <div class="floating-group flag-input">
                  <select
                    formControlName="nacionalidad"
                    id="nacionalidad"
                    (change)="onCountryChange($event, 'nacionalidad3')"
                  >
                    <option value="" disabled selected hidden></option>
                    <option
                      *ngFor="let country of countryPhoneOptions"
                      [value]="country.name"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                  <label>Nacionalidad</label>
                  <img
                    class="flag-icon"
                    *ngIf="beneficiarioFinalForm2.get('nacionalidad')?.value"
                    [src]="
                      'assets/flags/' +
                      getFlagForCountry(
                        beneficiarioFinalForm2.get('nacionalidad')?.value
                      )
                    "
                    alt="Bandera"
                  />
                </div>
              </div>
            </div>

            <div class="form-grid">
              <div class="floating-group">
                <select
                  class="form-control"
                  formControlName="porcentaje_participacion"
                  id="porcentaje_participacion"
                >
                  <option value="">Seleccione un porcentaje</option>
                  <option
                    *ngFor="let porcentaje of porcentajes"
                    [value]="porcentaje"
                  >
                    {{ porcentaje }}%
                  </option>
                </select>
                <label for="">Porcentaje de participación</label>
              </div>

              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="direccion_particular"
                  id="direccion_particular"
                />
                <label for="direccion_particular">Dirección particular</label>
              </div>
            </div>
            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="tipo_departamento"
                />
                <label for="tipo_departamento"
                  >N° de departamento (solo si aplica)</label
                >
              </div>

              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="comuna"
                  id="comuna"
                />
                <label for="comuna">Comuna</label>
              </div>
            </div>

            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="ciudad"
                  id="ciudad"
                />
                <label for="ciudad">Ciudad</label>
              </div>

              <div class="floating-group flag-input">
                <select
                  formControlName="pais_direccion"
                  id="pais_direccion"
                  (change)="onCountryChange($event, 'paisDir2')"
                >
                  <option value="" disabled selected hidden></option>
                  <option
                    *ngFor="let country of countryPhoneOptions"
                    [value]="country.name"
                  >
                    {{ country.name }}
                  </option>
                </select>
                <label>Pais de direccion</label>
                <img
                  class="flag-icon"
                  *ngIf="beneficiarioFinalForm2.get('pais_direccion')?.value"
                  [src]="
                    'assets/flags/' +
                    getFlagForCountry(
                      beneficiarioFinalForm2.get('pais_direccion')?.value
                    )
                  "
                  alt="Bandera"
                />
              </div>
            </div>

            <p class="main-question text-center">
              Documento Nacional de Identidad
            </p>

            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="file"
                  id="documento_frontal"
                  (change)="onFileSelected2($event, 'documento_frontal')"
                  accept=".jpg, .jpeg, .png"
                  #fileInput
                />
                <label for="documento_frontal"
                  >Adjunte su documento FRONTAL</label
                >
                <small
                  class="block text-xs sm:text-sm text-gray-500 mt-1 text-center"
                  >Máximo 5 MB - Formatos PNG, JPG y JPEG</small
                >
              </div>

              <div class="floating-group">
                <input
                  type="file"
                  id="documento_reverso"
                  (change)="onFileSelected2($event, 'documento_reverso')"
                  accept=".jpg, .jpeg, .png"
                  #fileInput
                />
                <label for="documento_reverso"
                  >Adjunte su documento REVERSO</label
                >
                <small
                  class="block text-xs sm:text-sm text-gray-500 mt-1 text-center"
                  >Máximo 10 MB - Formatos PNG, JPG y JPEG</small
                >
              </div>
            </div>

            <div class="form-grid mt-3">
              <div class="floating-group">
                <input
                  type="date"
                  class="form-control"
                  formControlName="fecha_vencimiento_dni"
                  id="fecha_vencimiento_dni"
                />
                <label for="fecha_vencimiento_dni"
                  >Fecha de vencimiento del DNI</label
                >
              </div>
            </div>

            <p class="main-question mt-2 text-center">
              ¿Desempeña o ha desempeñado funciones públicas (PEP)?
            </p>
            <div class="form-grid self-center">
              <label class="checkbox-wrapper">
                <input
                  type="checkbox"
                  formControlName="es_pep"
                  (change)="onPepToggle2()"
                />
                <span class="checkmark"></span> Sí, soy/he sido PEP
              </label>
            </div>

            <div *ngIf="beneficiarioFinalForm2.get('es_pep')?.value">
              <div class="form-grid">
                <div class="floating-group">
                  <select
                    formControlName="pep_funcion"
                    id="pep_funcion"
                    class="form-control"
                  >
                    <option value="" disabled selected hidden></option>
                    <option value="Presidente de la República">
                      Presidente de la República
                    </option>
                    <option value="Senadores, diputados y alcaldes">
                      Senadores, diputados y alcaldes
                    </option>
                    <option
                      value="Ministros de la Corte Suprema y Cortes de Apelaciones"
                    >
                      Ministros de la Corte Suprema y Cortes de Apelaciones
                    </option>
                    <option value="Ministros de Estado">
                      Ministros de Estado
                    </option>
                    <option value="Subsecretarios">Subsecretarios</option>
                    <option value="Intendentes">Intendentes</option>
                    <option value="Gobernadores">Gobernadores</option>
                    <option value="Secretarios Regionales Ministeriales">
                      Secretarios Regionales Ministeriales
                    </option>
                    <option value="Embajadores">Embajadores</option>
                    <option
                      value="Jefes superiores de servicio (centralizados y descentralizados)"
                    >
                      Jefes superiores de servicio (centralizados y
                      descentralizados)
                    </option>
                    <option
                      value="Directivo superior inmediato que subrogue a los anteriores"
                    >
                      Directivo superior inmediato que subrogue a los anteriores
                    </option>
                    <option value="Comandantes en Jefe de las Fuerzas Armadas">
                      Comandantes en Jefe de las Fuerzas Armadas
                    </option>
                    <option value="Director General de Carabineros">
                      Director General de Carabineros
                    </option>
                    <option value="Director General de Investigaciones">
                      Director General de Investigaciones
                    </option>
                    <option
                      value="Oficial superior inmediato que subrogue a los anteriores"
                    >
                      Oficial superior inmediato que subrogue a los anteriores
                    </option>
                    <option value="Fiscales Regionales">
                      Fiscales Regionales
                    </option>
                    <option value="Contralor General de la República">
                      Contralor General de la República
                    </option>
                    <option value="Consejeros del Banco Central de Chile">
                      Consejeros del Banco Central de Chile
                    </option>
                    <option
                      value="Consejeros del Consejo de Defensa del Estado"
                    >
                      Consejeros del Consejo de Defensa del Estado
                    </option>
                    <option
                      value="Ministros del Tribunal de la Libre Competencia"
                    >
                      Ministros del Tribunal de la Libre Competencia
                    </option>
                    <option
                      value="Integrantes titulares y suplentes del Tribunal de Contratación Pública"
                    >
                      Integrantes titulares y suplentes del Tribunal de
                      Contratación Pública
                    </option>
                    <option
                      value="Consejeros del Consejo de Alta Dirección Pública"
                    >
                      Consejeros del Consejo de Alta Dirección Pública
                    </option>
                    <option
                      value="Directores y ejecutivos principales de empresas públicas (según Ley N° 18.045)"
                    >
                      Directores y ejecutivos principales de empresas públicas
                      (según Ley N° 18.045)
                    </option>
                    <option
                      value="Directores de sociedades anónimas nombrados por el Estado o sus organismos"
                    >
                      Directores de sociedades anónimas nombrados por el Estado
                      o sus organismos
                    </option>
                    <option
                      value="Miembros de las directivas de los partidos políticos"
                    >
                      Miembros de las directivas de los partidos políticos
                    </option>
                    <option value="Otros">Otros</option>
                  </select>
                  <label for="pep_funcion">¿Qué funciones desempeñó?</label>
                </div>

                <div class="floating-group">
                  <input
                    type="text"
                    id="pep_institucion"
                    formControlName="pep_institucion"
                    class="form-control"
                    placeholder="Ingrese la institución"
                  />
                  <label for="pep_institucion">¿En qué institución?</label>
                </div>
              </div>

              <div class="form-grid mt-4">
                <div class="floating-group">
                  <input
                    type="date"
                    class="form-control"
                    formControlName="pep_fecha_inicio"
                    id="pep_fecha_inicio"
                  />
                  <label for="pep_fecha_inicio">Fecha de inicio</label>
                </div>

                <div class="floating-group">
                  <input
                    type="date"
                    class="form-control"
                    formControlName="pep_fecha_termino"
                    id="pep_fecha_termino"
                  />
                  <label for="pep_fecha_termino">Fecha de término</label>
                </div>
              </div>
            </div>

            <p class="subtext">
              Los datos personales otorgados se utilizarán solo por
              <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
              conocimiento de sus clientes. No serán divulgados ni puestos en
              conocimiento público, esto conforme al cumplimiento de la Ley N°
              19.628 sobre Protección de Vida Privada.
            </p>

            <button type="submit" [disabled]="!beneficiarioFinalForm2.valid">
              Continuar
            </button>
            <button type="button" (click)="openBeneficiaryForm = false">
              Cancelar
            </button>
          </form>
        </div>
      </div>

      <ng-template #noBeneficiaries>
        <p class="subtext">No se han ingresado beneficiarios finales aún.</p>
      </ng-template>
    </div>
    <div class="existing-beneficiaries">
      <div class="form-grid justify-between py-2">
        <p class="main-question italic self-center">
          2. Datos representantes legales ({{ representantes.length }})
          <mat-icon
            matTooltip="Son las personas naturales facultadas legalmente para actuar en nombre de la empresa (por ejemplo, firmar contratos, abrir cuentas, representar ante organismos públicos).
👉 Ejemplo: El Gerente General o el apoderado inscrito en el Registro de Empresas  Sociedades.
"
            matTooltipPosition="right"
            class="text-sm cursor-pointer align-middle"
            fontIcon="help_outline"
            inline
          ></mat-icon>
        </p>
        <button
          type="button"
          class="text-xs flex items-center justify-between bg-[#154D39] text-white w-fit shadow-md"
          (click)="addRepresentanteLegal()"
        >
          <span class="font-semibold">Ingresar representantes legales</span>
          <mat-icon fontIcon="add"></mat-icon>
        </button>
      </div>
      <div class="form-grid justify-end py-2">
        <div class="relative inline-block self-center">
          <!-- Icon positioned absolutely inside the select -->
          <mat-icon
            fontIcon="search"
            class="absolute left-2 top-1/2 z-50 transform -translate-y-1/2 text-[#154D39] text-base pointer-events-none"
          ></mat-icon>

          <!-- The select with left padding to make room for the icon -->
          <select
            class="w-260 text-xs pl-9 py-1.5 rounded border border-[#D5F6DA] bg-white text-[#154D39] focus:outline-none focus:ring-2 focus:ring-[#09342D] transition duration-150"
            (change)="addRepresentanteFromBeneficiario($event)"
            id="RepresentanteFromBeneficiario"
          >
            <option value="" class="bg-white text-[#154D39]">
              ¿Utilizar datos de socio ya creado?
            </option>
            <option
              *ngFor="let b of beneficiarios; let i = index"
              [value]="i"
              class="bg-white text-[#154D39]"
            >
              {{ b.nombres }} {{ b.apellidos }}
            </option>
          </select>
        </div>
      </div>
      <div
        *ngIf="representantes.length > 0; else noRepresentantes"
        class="space-y-4"
      >
        <div
          class="beneficiary-item flex place-content-around gap-4 p-4 shadow-sm bg-white"
          *ngFor="let representante of representantes"
        >
          <div class="text-sm space-y-1">
            <p>
              <span class="text-gray-500 font-normal">Nombres: </span>
              <span class="[color:#09342D]">{{ representante.nombres }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal">Apellidos: </span>
              <span class="[color:#09342D]">{{ representante.apellidos }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal"
                >Cédula de identidad:
              </span>
              <span class="[color:#09342D]">{{ representante.rut }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal">¿PEP?: </span>
              <span class="[color:#09342D]">{{
                representante.es_pep ? "Sí" : "No"
              }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal">Participación: </span>
              <span class="[color:#09342D]"
                >{{ representante.porcentaje_participacion }}%</span
              >
            </p>
          </div>
          <button
            *ngIf="!representante._autoPopulated"
            class="flex items-center gap-1 [color:#FF2048] hover:[color:#e10032] text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="deleteRepresentante(representante.id)"
          >
            Eliminar
          </button>
          <span *ngIf="representante._autoPopulated" class="text-xs text-gray-400 italic">
            Rep. Legal (OCR)
          </span>
        </div>
      </div>
      <div *ngIf="openRepresentanteForm" class="modal-backdrop">
        <div class="modal-content">
          <form
            [formGroup]="representantesLegalesForm"
            (ngSubmit)="addNewRepresentante()"
            class="form-wrapper mt-1"
          >
            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="nombres"
                  id="nombres"
                />
                <label for="nombres">Nombres</label>
              </div>

              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="apellidos"
                  id="apellidos"
                />
                <label for="apellidos">Apellidos</label>
              </div>
            </div>

            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="rut"
                  id="rut"
                />
                <label for="rut">RUT</label>
              </div>

              <div class="floating-group">
                <div class="floating-group flag-input">
                  <select
                    formControlName="nacionalidad"
                    id="nacionalidad"
                    (change)="onCountryChange($event, 'nacionalidad4')"
                  >
                    <option value="" disabled selected hidden></option>
                    <option
                      *ngFor="let country of countryPhoneOptions"
                      [value]="country.name"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                  <label>Nacionalidad</label>
                  <img
                    class="flag-icon"
                    *ngIf="representantesLegalesForm.get('nacionalidad')?.value"
                    [src]="
                      'assets/flags/' +
                      getFlagForCountry(
                        representantesLegalesForm.get('nacionalidad')?.value
                      )
                    "
                    alt="Bandera"
                  />
                </div>
              </div>
            </div>

            <div class="form-grid">
              <div class="floating-group">
                <select
                  class="form-control"
                  formControlName="porcentaje_participacion"
                  id="porcentaje_participacion"
                >
                  <option value="">Seleccione un porcentaje</option>
                  <option
                    *ngFor="let porcentaje of porcentajes"
                    [value]="porcentaje"
                  >
                    {{ porcentaje }}%
                  </option>
                </select>
                <label for="">Porcentaje de participación</label>
              </div>

              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="direccion_particular"
                  id="direccion_particular"
                />
                <label for="direccion_particular">Dirección particular</label>
              </div>
            </div>
            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="tipo_departamento"
                />
                <label for="tipo_departamento"
                  >N° de departamento (solo si aplica)</label
                >
              </div>

              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="comuna"
                  id="comuna"
                />
                <label for="comuna">Comuna</label>
              </div>
            </div>

            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="ciudad"
                  id="ciudad"
                />
                <label for="ciudad">Ciudad</label>
              </div>

              <div class="floating-group flag-input">
                <select
                  formControlName="pais_direccion"
                  id="pais_direccion"
                  (change)="onCountryChange($event, 'paisDir3')"
                >
                  <option value="" disabled selected hidden></option>
                  <option
                    *ngFor="let country of countryPhoneOptions"
                    [value]="country.name"
                  >
                    {{ country.name }}
                  </option>
                </select>
                <label>Pais de direccion</label>
                <img
                  class="flag-icon"
                  *ngIf="representantesLegalesForm.get('pais_direccion')?.value"
                  [src]="
                    'assets/flags/' +
                    getFlagForCountry(
                      representantesLegalesForm.get('pais_direccion')?.value
                    )
                  "
                  alt="Bandera"
                />
              </div>
            </div>

            <p class="main-question text-center">
              Documento Nacional de Identidad
            </p>

            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="file"
                  id="documento_frontal"
                  (change)="onFileSelected3($event, 'documento_frontal')"
                  accept=".jpg, .jpeg, .png"
                  #fileInput
                />
                <label for="documento_frontal"
                  >Adjunte su documento FRONTAL</label
                >
                <small
                  class="block text-xs sm:text-sm text-gray-500 mt-1 text-center"
                  >Máximo 5 MB - Formatos PNG, JPG y JPEG</small
                >
              </div>

              <div class="floating-group">
                <input
                  type="file"
                  id="documento_reverso"
                  (change)="onFileSelected3($event, 'documento_reverso')"
                  accept=".jpg, .jpeg, .png"
                  #fileInput
                />
                <label for="documento_reverso"
                  >Adjunte su documento REVERSO</label
                >
                <small
                  class="block text-xs sm:text-sm text-gray-500 mt-1 text-center"
                  >Máximo 10 MB - Formatos PNG, JPG y JPEG</small
                >
              </div>
            </div>

            <div class="form-grid mt-3">
              <div class="floating-group">
                <input
                  type="date"
                  class="form-control"
                  formControlName="fecha_vencimiento_dni"
                  id="fecha_vencimiento_dni"
                />
                <label for="fecha_vencimiento_dni"
                  >Fecha de vencimiento del DNI</label
                >
              </div>
            </div>

            <p class="main-question mt-2 text-center">
              ¿Desempeña o ha desempeñado funciones públicas (PEP)?
            </p>
            <div class="form-grid self-center">
              <label class="checkbox-wrapper">
                <input
                  type="checkbox"
                  formControlName="es_pep"
                  (change)="onPepToggle3()"
                />
                <span class="checkmark"></span> Sí, soy/he sido PEP
              </label>
            </div>

            <div *ngIf="representantesLegalesForm.get('es_pep')?.value">
              <div class="form-grid">
                <div class="floating-group">
                  <select
                    formControlName="pep_funcion"
                    id="pep_funcion"
                    class="form-control"
                  >
                    <option value="" disabled selected hidden></option>
                    <option value="Presidente de la República">
                      Presidente de la República
                    </option>
                    <option value="Senadores, diputados y alcaldes">
                      Senadores, diputados y alcaldes
                    </option>
                    <option
                      value="Ministros de la Corte Suprema y Cortes de Apelaciones"
                    >
                      Ministros de la Corte Suprema y Cortes de Apelaciones
                    </option>
                    <option value="Ministros de Estado">
                      Ministros de Estado
                    </option>
                    <option value="Subsecretarios">Subsecretarios</option>
                    <option value="Intendentes">Intendentes</option>
                    <option value="Gobernadores">Gobernadores</option>
                    <option value="Secretarios Regionales Ministeriales">
                      Secretarios Regionales Ministeriales
                    </option>
                    <option value="Embajadores">Embajadores</option>
                    <option
                      value="Jefes superiores de servicio (centralizados y descentralizados)"
                    >
                      Jefes superiores de servicio (centralizados y
                      descentralizados)
                    </option>
                    <option
                      value="Directivo superior inmediato que subrogue a los anteriores"
                    >
                      Directivo superior inmediato que subrogue a los anteriores
                    </option>
                    <option value="Comandantes en Jefe de las Fuerzas Armadas">
                      Comandantes en Jefe de las Fuerzas Armadas
                    </option>
                    <option value="Director General de Carabineros">
                      Director General de Carabineros
                    </option>
                    <option value="Director General de Investigaciones">
                      Director General de Investigaciones
                    </option>
                    <option
                      value="Oficial superior inmediato que subrogue a los anteriores"
                    >
                      Oficial superior inmediato que subrogue a los anteriores
                    </option>
                    <option value="Fiscales Regionales">
                      Fiscales Regionales
                    </option>
                    <option value="Contralor General de la República">
                      Contralor General de la República
                    </option>
                    <option value="Consejeros del Banco Central de Chile">
                      Consejeros del Banco Central de Chile
                    </option>
                    <option
                      value="Consejeros del Consejo de Defensa del Estado"
                    >
                      Consejeros del Consejo de Defensa del Estado
                    </option>
                    <option
                      value="Ministros del Tribunal de la Libre Competencia"
                    >
                      Ministros del Tribunal de la Libre Competencia
                    </option>
                    <option
                      value="Integrantes titulares y suplentes del Tribunal de Contratación Pública"
                    >
                      Integrantes titulares y suplentes del Tribunal de
                      Contratación Pública
                    </option>
                    <option
                      value="Consejeros del Consejo de Alta Dirección Pública"
                    >
                      Consejeros del Consejo de Alta Dirección Pública
                    </option>
                    <option
                      value="Directores y ejecutivos principales de empresas públicas (según Ley N° 18.045)"
                    >
                      Directores y ejecutivos principales de empresas públicas
                      (según Ley N° 18.045)
                    </option>
                    <option
                      value="Directores de sociedades anónimas nombrados por el Estado o sus organismos"
                    >
                      Directores de sociedades anónimas nombrados por el Estado
                      o sus organismos
                    </option>
                    <option
                      value="Miembros de las directivas de los partidos políticos"
                    >
                      Miembros de las directivas de los partidos políticos
                    </option>
                    <option value="Otros">Otros</option>
                  </select>
                  <label for="pep_funcion">¿Qué funciones desempeñó?</label>
                </div>

                <div class="floating-group">
                  <input
                    type="text"
                    id="pep_institucion"
                    formControlName="pep_institucion"
                    class="form-control"
                    placeholder="Ingrese la institución"
                  />
                  <label for="pep_institucion">¿En qué institución?</label>
                </div>
              </div>

              <div class="form-grid mt-4">
                <div class="floating-group">
                  <input
                    type="date"
                    class="form-control"
                    formControlName="pep_fecha_inicio"
                    id="pep_fecha_inicio"
                  />
                  <label for="pep_fecha_inicio">Fecha de inicio</label>
                </div>

                <div class="floating-group">
                  <input
                    type="date"
                    class="form-control"
                    formControlName="pep_fecha_termino"
                    id="pep_fecha_termino"
                  />
                  <label for="pep_fecha_termino">Fecha de término</label>
                </div>
              </div>
            </div>

            <p class="subtext">
              Los datos personales otorgados se utilizarán solo por
              <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
              conocimiento de sus clientes. No serán divulgados ni puestos en
              conocimiento público, esto conforme al cumplimiento de la Ley N°
              19.628 sobre Protección de Vida Privada.
            </p>

            <button type="submit" [disabled]="!representantesLegalesForm.valid">
              Continuar
            </button>
            <button type="button" (click)="onCancel2()">Cancelar</button>
          </form>
        </div>
      </div>

      <ng-template #noRepresentantes>
        <p class="subtext">No se han ingresado representantes legales aún.</p>
      </ng-template>
    </div>
    <div class="existing-beneficiaries">
      <div class="form-grid justify-between py-2">
        <p class="main-question italic self-center">
          3. Datos de personas con control efectivo ({{
            controlEfectivo.length
          }})
          <mat-icon
            matTooltip="Son quienes, sin necesariamente tener participación directa en la propiedad, toman decisiones estratégicas o influyen de manera relevante en la administración de la empresa.
👉 Ejemplo: Directores, socios controladores indirectos o personas con poder de decisión.
"
            matTooltipPosition="right"
            class="text-sm cursor-pointer align-middle"
            fontIcon="help_outline"
            inline
          ></mat-icon>
        </p>
        <button
          type="button"
          class="text-xs flex items-center justify-between bg-[#154D39] text-white w-fit shadow-md"
          (click)="addControlEfectivo()"
        >
          <span class="font-semibold"
            >Ingresar persona con control efectivo</span
          >
          <mat-icon fontIcon="add"></mat-icon>
        </button>
      </div>
      <div class="form-grid justify-end py-2">
        <div class="relative inline-block self-center">
          <mat-icon
            fontIcon="search"
            class="absolute left-2 top-1/2 z-50 transform -translate-y-1/2 text-[#154D39] text-base pointer-events-none"
          ></mat-icon>

          <select
            class="w-260 text-xs pl-9 py-1.5 rounded border border-[#D5F6DA] bg-white text-[#154D39] focus:outline-none focus:ring-2 focus:ring-[#09342D] transition duration-150"
            (change)="addControlEfectivoFromBeneficiario($event)"
            id="RepresentanteFromBeneficiario"
          >
            <option value="" class="bg-white text-[#154D39]">
              ¿Utilizar datos de socio ya creado?
            </option>
            <option
              *ngFor="let b of beneficiarios; let i = index"
              [value]="i"
              class="bg-white text-[#154D39]"
            >
              {{ b.nombres }} {{ b.apellidos }}
            </option>
          </select>
        </div>
      </div>
      <div
        *ngIf="controlEfectivo.length > 0; else noControlEfectivo"
        class="space-y-4"
      >
        <div
          class="beneficiary-item flex place-content-around gap-4 p-4 shadow-sm bg-white"
          *ngFor="let persona of controlEfectivo"
        >
          <div class="text-sm space-y-1">
            <p>
              <span class="text-gray-500 font-normal">Nombres: </span>
              <span class="[color:#09342D]">{{ persona.nombres }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal">Apellidos: </span>
              <span class="[color:#09342D]">{{ persona.apellidos }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal"
                >Cédula de identidad:
              </span>
              <span class="[color:#09342D]">{{ persona.rut }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal">¿PEP?: </span>
              <span class="[color:#09342D]">{{
                persona.es_pep ? "Sí" : "No"
              }}</span>
            </p>
            <p>
              <span class="text-gray-500 font-normal">Participación: </span>
              <span class="[color:#09342D]"
                >{{ persona.porcentaje_participacion }}%</span
              >
            </p>
          </div>
          <button
            *ngIf="!persona._autoPopulated"
            class="flex items-center gap-1 [color:#FF2048] hover:[color:#e10032] text-xs font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="deleteControlEfectivo(persona.id)"
          >
            Eliminar
          </button>
          <span *ngIf="persona._autoPopulated" class="text-xs text-gray-400 italic">
            Auto
          </span>
        </div>
      </div>
      <div *ngIf="openControlEfectivo" class="modal-backdrop">
        <div class="modal-content">
          <form
            [formGroup]="controlEfectivoForm"
            (ngSubmit)="addNewControlEfectivo()"
            class="form-wrapper mt-1"
          >
            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="nombres"
                  id="nombres"
                />
                <label for="nombres">Nombres</label>
              </div>

              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="apellidos"
                  id="apellidos"
                />
                <label for="apellidos">Apellidos</label>
              </div>
            </div>

            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="rut"
                  id="rut"
                />
                <label for="rut">RUT</label>
              </div>

              <div class="floating-group">
                <div class="floating-group flag-input">
                  <select
                    formControlName="nacionalidad"
                    id="nacionalidad"
                    (change)="onCountryChange($event, 'nacionalidad5')"
                  >
                    <option value="" disabled selected hidden></option>
                    <option
                      *ngFor="let country of countryPhoneOptions"
                      [value]="country.name"
                    >
                      {{ country.name }}
                    </option>
                  </select>
                  <label>Nacionalidad</label>
                  <img
                    class="flag-icon"
                    *ngIf="controlEfectivoForm.get('nacionalidad')?.value"
                    [src]="
                      'assets/flags/' +
                      getFlagForCountry(
                        controlEfectivoForm.get('nacionalidad')?.value
                      )
                    "
                    alt="Bandera"
                  />
                </div>
              </div>
            </div>

            <div class="form-grid">
              <div class="floating-group">
                <select
                  class="form-control"
                  formControlName="porcentaje_participacion"
                  id="porcentaje_participacion"
                >
                  <option value="">Seleccione un porcentaje</option>
                  <option
                    *ngFor="let porcentaje of porcentajes"
                    [value]="porcentaje"
                  >
                    {{ porcentaje }}%
                  </option>
                </select>
                <label for="">Porcentaje de participación</label>
              </div>

              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="direccion_particular"
                  id="direccion_particular"
                />
                <label for="direccion_particular">Dirección particular</label>
              </div>
            </div>
            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="tipo_departamento"
                />
                <label for="tipo_departamento"
                  >N° de departamento (solo si aplica)</label
                >
              </div>

              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="comuna"
                  id="comuna"
                />
                <label for="comuna">Comuna</label>
              </div>
            </div>

            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="ciudad"
                  id="ciudad"
                />
                <label for="ciudad">Ciudad</label>
              </div>

              <div class="floating-group flag-input">
                <select
                  formControlName="pais_direccion"
                  id="pais_direccion"
                  (change)="onCountryChange($event, 'paisDir4')"
                >
                  <option value="" disabled selected hidden></option>
                  <option
                    *ngFor="let country of countryPhoneOptions"
                    [value]="country.name"
                  >
                    {{ country.name }}
                  </option>
                </select>
                <label>Pais de direccion</label>
                <img
                  class="flag-icon"
                  *ngIf="controlEfectivoForm.get('pais_direccion')?.value"
                  [src]="
                    'assets/flags/' +
                    getFlagForCountry(
                      controlEfectivoForm.get('pais_direccion')?.value
                    )
                  "
                  alt="Bandera"
                />
              </div>
            </div>

            <p class="main-question text-center">
              Documento Nacional de Identidad
            </p>

            <div class="form-grid">
              <div class="floating-group">
                <input
                  type="file"
                  id="documento_frontal"
                  (change)="onFileSelected4($event, 'documento_frontal')"
                  accept=".jpg, .jpeg, .png"
                  #fileInput
                />
                <label for="documento_frontal"
                  >Adjunte su documento FRONTAL</label
                >
                <small
                  class="block text-xs sm:text-sm text-gray-500 mt-1 text-center"
                  >Máximo 5 MB - Formatos PNG, JPG y JPEG</small
                >
              </div>

              <div class="floating-group">
                <input
                  type="file"
                  id="documento_reverso"
                  (change)="onFileSelected4($event, 'documento_reverso')"
                  accept=".jpg, .jpeg, .png"
                  #fileInput
                />
                <label for="documento_reverso"
                  >Adjunte su documento REVERSO</label
                >
                <small
                  class="block text-xs sm:text-sm text-gray-500 mt-1 text-center"
                  >Máximo 10 MB - Formatos PNG, JPG y JPEG</small
                >
              </div>
            </div>

            <div class="form-grid mt-3">
              <div class="floating-group">
                <input
                  type="date"
                  class="form-control"
                  formControlName="fecha_vencimiento_dni"
                  id="fecha_vencimiento_dni"
                />
                <label for="fecha_vencimiento_dni"
                  >Fecha de vencimiento del DNI</label
                >
              </div>
            </div>

            <p class="main-question mt-2 text-center">
              ¿Desempeña o ha desempeñado funciones públicas (PEP)?
            </p>
            <div class="form-grid self-center">
              <label class="checkbox-wrapper">
                <input
                  type="checkbox"
                  formControlName="es_pep"
                  (change)="onPepToggle3()"
                />
                <span class="checkmark"></span> Sí, soy/he sido PEP
              </label>
            </div>

            <div *ngIf="controlEfectivoForm.get('es_pep')?.value">
              <div class="form-grid">
                <div class="floating-group">
                  <select
                    formControlName="pep_funcion"
                    id="pep_funcion"
                    class="form-control"
                  >
                    <option value="" disabled selected hidden></option>
                    <option value="Presidente de la República">
                      Presidente de la República
                    </option>
                    <option value="Senadores, diputados y alcaldes">
                      Senadores, diputados y alcaldes
                    </option>
                    <option
                      value="Ministros de la Corte Suprema y Cortes de Apelaciones"
                    >
                      Ministros de la Corte Suprema y Cortes de Apelaciones
                    </option>
                    <option value="Ministros de Estado">
                      Ministros de Estado
                    </option>
                    <option value="Subsecretarios">Subsecretarios</option>
                    <option value="Intendentes">Intendentes</option>
                    <option value="Gobernadores">Gobernadores</option>
                    <option value="Secretarios Regionales Ministeriales">
                      Secretarios Regionales Ministeriales
                    </option>
                    <option value="Embajadores">Embajadores</option>
                    <option
                      value="Jefes superiores de servicio (centralizados y descentralizados)"
                    >
                      Jefes superiores de servicio (centralizados y
                      descentralizados)
                    </option>
                    <option
                      value="Directivo superior inmediato que subrogue a los anteriores"
                    >
                      Directivo superior inmediato que subrogue a los anteriores
                    </option>
                    <option value="Comandantes en Jefe de las Fuerzas Armadas">
                      Comandantes en Jefe de las Fuerzas Armadas
                    </option>
                    <option value="Director General de Carabineros">
                      Director General de Carabineros
                    </option>
                    <option value="Director General de Investigaciones">
                      Director General de Investigaciones
                    </option>
                    <option
                      value="Oficial superior inmediato que subrogue a los anteriores"
                    >
                      Oficial superior inmediato que subrogue a los anteriores
                    </option>
                    <option value="Fiscales Regionales">
                      Fiscales Regionales
                    </option>
                    <option value="Contralor General de la República">
                      Contralor General de la República
                    </option>
                    <option value="Consejeros del Banco Central de Chile">
                      Consejeros del Banco Central de Chile
                    </option>
                    <option
                      value="Consejeros del Consejo de Defensa del Estado"
                    >
                      Consejeros del Consejo de Defensa del Estado
                    </option>
                    <option
                      value="Ministros del Tribunal de la Libre Competencia"
                    >
                      Ministros del Tribunal de la Libre Competencia
                    </option>
                    <option
                      value="Integrantes titulares y suplentes del Tribunal de Contratación Pública"
                    >
                      Integrantes titulares y suplentes del Tribunal de
                      Contratación Pública
                    </option>
                    <option
                      value="Consejeros del Consejo de Alta Dirección Pública"
                    >
                      Consejeros del Consejo de Alta Dirección Pública
                    </option>
                    <option
                      value="Directores y ejecutivos principales de empresas públicas (según Ley N° 18.045)"
                    >
                      Directores y ejecutivos principales de empresas públicas
                      (según Ley N° 18.045)
                    </option>
                    <option
                      value="Directores de sociedades anónimas nombrados por el Estado o sus organismos"
                    >
                      Directores de sociedades anónimas nombrados por el Estado
                      o sus organismos
                    </option>
                    <option
                      value="Miembros de las directivas de los partidos políticos"
                    >
                      Miembros de las directivas de los partidos políticos
                    </option>
                    <option value="Otros">Otros</option>
                  </select>
                  <label for="pep_funcion">¿Qué funciones desempeñó?</label>
                </div>

                <div class="floating-group">
                  <input
                    type="text"
                    id="pep_institucion"
                    formControlName="pep_institucion"
                    class="form-control"
                    placeholder="Ingrese la institución"
                  />
                  <label for="pep_institucion">¿En qué institución?</label>
                </div>
              </div>

              <div class="form-grid mt-4">
                <div class="floating-group">
                  <input
                    type="date"
                    class="form-control"
                    formControlName="pep_fecha_inicio"
                    id="pep_fecha_inicio"
                  />
                  <label for="pep_fecha_inicio">Fecha de inicio</label>
                </div>

                <div class="floating-group">
                  <input
                    type="date"
                    class="form-control"
                    formControlName="pep_fecha_termino"
                    id="pep_fecha_termino"
                  />
                  <label for="pep_fecha_termino">Fecha de término</label>
                </div>
              </div>
            </div>

            <p class="subtext">
              Los datos personales otorgados se utilizarán solo por
              <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
              conocimiento de sus clientes. No serán divulgados ni puestos en
              conocimiento público, esto conforme al cumplimiento de la Ley N°
              19.628 sobre Protección de Vida Privada.
            </p>

            <button type="submit" [disabled]="!controlEfectivoForm.valid">
              Continuar
            </button>
            <button type="button" (click)="onCancel3()">Cancelar</button>
          </form>
        </div>
      </div>

      <ng-template #noControlEfectivo>
        <p class="subtext">
          No se han ingresado personas con control efectivo aún.
        </p>
      </ng-template>
    </div>
    <button
      type="submit"
      (click)="nextStep()"
      [disabled]="
        isSavingStep ||
        !(
          beneficiarios.length > 0 &&
          representantes.length > 0 &&
          controlEfectivo.length > 0
        )
      "
    >
      {{ isSavingStep ? 'Guardando...' : 'Continuar' }}
    </button>
    <p
      class="subtext"
      *ngIf="
        openBeneficiaryForm === false &&
        openRepresentanteForm === false &&
        openControlEfectivo === false
      "
    >
      Los datos personales otorgados se utilizarán solo por
      <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
      conocimiento de sus clientes. No serán divulgados ni puestos en
      conocimiento público, esto conforme al cumplimiento de la Ley N° 19.628
      sobre Protección de Vida Privada.
    </p>
  </div>

  <div *ngIf="currentStep === 6 && !initialLoading" class="step-content slide-enter">
    <div class="progress-wrapper">
      <div class="progress-pill">Paso {{ currentStep }}/7</div>
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="(currentStep / 7) * 100"
        ></div>
      </div>
    </div>
    <form [formGroup]="documentacionForm">
      <p class="main-question"><strong>Documentación requerida</strong></p>

      <p class="subtext">Selecciona y añade la documentación requerida</p>

      <div class="empresa-select-wrapper">
        <label for="tipoEmpresa">Tipo de Empresa</label>
        <select
          id="tipoEmpresa"
          class="empresa-select"
          formControlName="tipoEmpresa"
          (change)="onTipoEmpresaChange()"
        >
          <option value="" disabled>Seleccione tipo de empresa</option>
          <option *ngFor="let tipo of tiposEmpresa" [value]="tipo">
            {{ tipo }}
          </option>
        </select>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-6">
        <ng-container *ngFor="let doc of documentosRequeridos">
          <ng-container *ngIf="requiredFields.includes(doc.control)">
            <div
              class="flex flex-col items-center justify-center p-4 rounded-xl w-[200px] min-h-[200px] border transition-all duration-300"
              [ngStyle]="
                filePreviews[doc.control]
                  ? {
                      'border-color': '#4E9C71',
                      'background-color': '#F1FFF4',
                      'border-style': 'dashed'
                    }
                  : {
                      'border-color': '#ccc',
                      'background-color': '#fff'
                    }
              "
            >
              <mat-icon
                *ngIf="!filePreviews[doc.control]"
                class="text-#color[4E9C71] mb-2"
                >upload</mat-icon
              >

              <label
                for="fileInput_{{ doc.control }}"
                class="flex flex-col items-center text-center text-sm cursor-pointer"
              >
                <div class="flex items-center gap-1 justify-center text-center">
                  <strong class="text-gray-800">{{ doc.label }}</strong>

                  <mat-icon
                    *ngIf="doc.label === 'Subir carpeta tributaria'"
                    style="color: #1e5a3f"
                    class="text-sm"
                    href="https://zeus.sii.cl/dii_cgi/carpeta_tributaria/cte_para_creditos_00.cgi"
                    matTooltip="🔄 Pasos para obtenerla:
1.	Ingresa a https://zeus.sii.cl/dii_cgi/carpeta_tributaria/cte_para_creditos_00.cgi con tu clave tributaria.
2.	Dirígete al menú “Servicios Online” > “Situación Tributaria” > “Carpeta Tributaria Electrónica para solicitar creditos”.
3.	Haz clic en la opción “Generar Carpeta: Acreditar Renta”.
4.	Descarga el documento generado (en formato PDF).
"
                    matTooltipPosition="above"
                  >
                    help_outline
                  </mat-icon>
                </div>

                <span class="text-gray-500 italic text-xs mt-1"
                  >Arrastra el archivo o haz clic</span
                >
              </label>

              <input
                type="file"
                id="fileInput_{{ doc.control }}"
                class="hidden"
                accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/jpg,image/png,application/pdf"
                (change)="onFileUpload($event, doc.control)"
                #fileInput
              />

              <div *ngIf="filePreviews[doc.control]" class="w-full mt-3">
                <img
                  *ngIf="isImage(filePreviews[doc.control])"
                  [src]="filePreviews[doc.control]"
                  alt="preview"
                  class="w-full h-auto rounded-md"
                />

                <div
                  *ngIf="isPdf(filePreviews[doc.control])"
                  class="flex items-center justify-center w-full h-32 bg-red-100 rounded-md text-red-500"
                >
                  <mat-icon class="text-4xl">picture_as_pdf</mat-icon>
                </div>
                <div class="flex justify-between gap-4 mt-2">
                  <span
                    *ngIf="doc.control.startsWith('extra_')"
                    (click)="removeExtraField(doc.control)"
                    class="cursor-pointer text-red-500 text-xs hover:text-red-700"
                  >
                    Quitar campo
                  </span>
                  <span
                    (click)="removeFile(doc.control)"
                    class="cursor-pointer text-red-500 text-xs hover:text-red-700"
                  >
                    Eliminar archivo
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <!-- <div class="mt-6 text-center text-sm text-[#154D39]">
        En caso de que necesites adjuntar otro archivo. Utiliza el siguiente
        botón:
      </div> -->
      <!-- <button
        type="submit"
        class="mt-2 px-4 py-2 bg-white rounded-lg hover:bg-[#F0FAF4] text-[#154D39] font-bold text-base flex items-center gap-2 justify-self-center"
        style="border: 1px solid #154d39"
        (click)="addExtraField()"
      >
        Añadir adjunto adicional
        <mat-icon
          class="text-2xl !leading-none font-bold"
          fontIcon="add_2"
        ></mat-icon>
      </button> -->
    </form>

    <button
      type="submit"
      (click)="nextStep()"
      [disabled]="!documentacionForm.valid || isSavingStep"
    >
      {{ isSavingStep ? 'Guardando...' : 'Continuar' }}
    </button>

    <p class="subtext">
      Los datos personales otorgados se utilizarán solo por
      <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
      conocimiento de sus clientes. No serán divulgados ni puestos en
      conocimiento público, esto conforme al cumplimiento de la Ley N° 19.628
      sobre Protección de Vida Privada.
    </p>
  </div>
  <div *ngIf="currentStep === 7 && !initialLoading" class="step-content slide-enter">
    <div class="progress-wrapper">
      <div class="progress-pill">Paso {{ currentStep }}/7</div>
      <div class="progress-bar">
        <div
          class="progress-fill"
          [style.width.%]="(currentStep / 7) * 100"
        ></div>
      </div>
    </div>
    <p class="main-question text-center">
      <strong>Confirmacion final</strong>
    </p>
    <p class="subtext text-center">
      Revisa que toda tu informacion es correcta antes de enviar tu solicitud.
    </p>

    <!-- Confirmation Summary -->
    <div class="confirmation-summary">
      <!-- Representante Legal -->
      <div class="summary-section">
        <div class="summary-header">
          <mat-icon>person</mat-icon>
          <span>Representante Legal</span>
        </div>
        <div class="summary-content">
          <div class="summary-row">
            <span class="summary-label">Nombres:</span>
            <span class="summary-value">{{ representanteLegalForm.get('nombres')?.value }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">Apellidos:</span>
            <span class="summary-value">{{ representanteLegalForm.get('apellidos')?.value }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">RUT:</span>
            <span class="summary-value">{{ representanteLegalForm.get('rut')?.value }}</span>
          </div>
        </div>
        <div class="captured-thumbnails" *ngIf="documentFrontImage || selfieImage">
          <div class="thumbnail" *ngIf="documentFrontImage">
            <img [src]="documentFrontImage" alt="Documento frontal" />
            <span>Frontal</span>
          </div>
          <div class="thumbnail" *ngIf="documentBackImage">
            <img [src]="documentBackImage" alt="Documento reverso" />
            <span>Reverso</span>
          </div>
          <div class="thumbnail" *ngIf="selfieImage">
            <img [src]="selfieImage" alt="Selfie" class="selfie-thumb" />
            <span>Selfie</span>
          </div>
        </div>
      </div>

      <!-- Empresa -->
      <div class="summary-section">
        <div class="summary-header">
          <mat-icon>business</mat-icon>
          <span>Empresa</span>
        </div>
        <div class="summary-content">
          <div class="summary-row">
            <span class="summary-label">Razon Social:</span>
            <span class="summary-value">{{ personaJuridicaForm.get('razonSocial')?.value }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">RUT Empresa:</span>
            <span class="summary-value">{{ personaJuridicaForm.get('rut')?.value }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">Giro:</span>
            <span class="summary-value">{{ personaJuridicaForm.get('giroComercial')?.value }}</span>
          </div>
        </div>
      </div>

      <!-- Beneficiarios -->
      <div class="summary-section" *ngIf="beneficiarios.length > 0">
        <div class="summary-header">
          <mat-icon>group</mat-icon>
          <span>Beneficiarios ({{ beneficiarios.length }})</span>
        </div>
        <div class="summary-content">
          <div *ngFor="let b of beneficiarios" class="summary-row">
            <span class="summary-label">{{ b.nombres }} {{ b.apellidos }}</span>
            <span class="summary-value">{{ b.porcentaje_participacion }}%</span>
          </div>
        </div>
      </div>

      <!-- Representantes -->
      <div class="summary-section" *ngIf="representantes.length > 0">
        <div class="summary-header">
          <mat-icon>supervisor_account</mat-icon>
          <span>Representantes Legales ({{ representantes.length }})</span>
        </div>
        <div class="summary-content">
          <div *ngFor="let r of representantes" class="summary-row">
            <span class="summary-label">{{ r.nombres }} {{ r.apellidos }}</span>
            <span class="summary-value">{{ r.rut }}</span>
          </div>
        </div>
      </div>
    </div>

    <p class="subtext text-center">
      Los datos personales otorgados se utilizaran solo por
      <strong>Avocado Tech SpA - 77.974.055-2</strong> para el debido
      conocimiento de sus clientes. No seran divulgados ni puestos en
      conocimiento publico, esto conforme al cumplimiento de la Ley N 19.628
      sobre Proteccion de Vida Privada.
    </p>

    <button type="submit" (click)="submitFinalStep()" [disabled]="ocrLoading">
      {{ ocrLoading ? 'Enviando...' : 'Enviar solicitud' }}
    </button>
  </div>
  <div *ngIf="currentStep === 8 && !initialLoading" class="step-content slide-enter">
    <div class="progress-wrapper">
      <div class="progress-pill">Registro enviado</div>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="100"></div>
      </div>
    </div>
    <div class="text-center mt-4">
      <mat-icon style="font-size: 64px; width: 64px; height: 64px; color: #22c55e;">check_circle</mat-icon>
    </div>
    <p class="main-question text-3xl text-center mt-2">
      ¡Gracias por completar tu registro!
    </p>
    <p class="subtext text-center">
      Tu solicitud ha sido enviada exitosamente. Nuestro equipo revisará
      tu información y te notificaremos por correo electrónico.
      Este proceso puede tomar hasta 48 horas hábiles.
    </p>
    <button type="button" (click)="registrationCompleted = true; currentStep = 1;">
      Continuar
    </button>
  </div>
</div>
<div *ngIf="successMessage" class="floating-success">
  {{ successMessage }}
</div>
<div *ngIf="errorMessage" class="floating-error">
  {{ errorMessage }}
</div>
